"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2760],{

/***/ 28426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ delivery_guarantee; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/delivery-guarantee.styles.js



const Label = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  color: ${props => (0,esm.getTextColor)('scratched')(props)};
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm.themeGet)('fontWeights.regular')(props)};
`;
const GuaranteeText = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  margin-top: 16px;
  line-height: 1.25;
`;
const Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-weight: ${props => (0,esm.themeGet)('fontWeights.bold')(props)};
  color: ${props => (0,esm.getPaletteColor)('text.primary')(props)};
  line-height: 1.25;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/content-box.js






const ContentBox = _ref => {
  let {
    isMagaluCompany,
    onLinkClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["isMagaluCompany", "onLinkClick"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return isMagaluCompany ? /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "Empresa do", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    onClick: handleDetailsClick
  }, "Grupo Magalu"), ' ', "que garante sua compra do pedido \xE0 entrega.")) : /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "O Magalu garante a sua compra, do pedido \xE0 entrega.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  isMagaluCompany: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/guarantee-details.js






const GuaranteeDetails = ({
  text,
  title
}) => {
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 16
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(build_esm/* Guarantee */.hzV, {
    mr: 16,
    width: 45,
    height: 35
  }), /*#__PURE__*/react.createElement(Title, {
    "data-testid": "details-title"
  }, title)), /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 1
  }, text == null ? void 0 : text.map((textBlock, index) => /*#__PURE__*/react.createElement(GuaranteeText, {
    key: index
  }, textBlock))));
};

 false ? 0 : void 0;
GuaranteeDetails.defaultProps = {
  title: '',
  text: []
};
/* harmony default export */ var guarantee_details = (GuaranteeDetails);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/delivery-guarantee.js










const DeliveryGuarantee = _ref => {
  let {
    seller,
    showDialog,
    detailsText,
    detailsTitle,
    isMagaluCompany,
    onDetailsOpen,
    onDetailsClose
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["seller", "showDialog", "detailsText", "detailsTitle", "isMagaluCompany", "onDetailsOpen", "onDetailsClose"]);

  const {
    id
  } = seller;
  const [showDetails, setShowDetails] = (0,react.useState)(false);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (id === constants/* DEFAULT_SELLER */.ig) return null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    isMagaluCompany: isMagaluCompany,
    onLinkClick: openDetails
  }, props)), !showDialog && /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/react.createElement(Sidebar/* SidebarHeader */.$, {
    label: isMagaluCompany ? 'Empresa do Grupo Magalu' : 'Entrega e compra garantida',
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/react.createElement(guarantee_details, {
    text: detailsText,
    title: detailsTitle
  })), showDialog && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: showDetails,
    onClickOutside: closeDetails,
    type: "responsive",
    position: "center",
    width: "350px",
    titleStyle: {
      textAlign: 'center'
    },
    showClose: true
  }, /*#__PURE__*/react.createElement(guarantee_details, {
    text: detailsText,
    title: detailsTitle
  })));
};

 false ? 0 : void 0;
DeliveryGuarantee.defaultProps = {
  seller: {
    id: 'magazineluiza'
  },
  detailsText: [],
  detailsTitle: '',
  showDialog: false,
  isMagaluCompany: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
/* harmony default export */ var delivery_guarantee = (DeliveryGuarantee);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/index.js


/***/ }),

/***/ 90713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ fast_filter; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/fast-filter.styles.js




const Container = styled_components_browser_esm["default"].div`
  width: 100%;
  padding: ${props => (0,esm.themeGet)('space.2')(props)}px;
  ${({
  desktopMode
}) => !desktopMode && styled_components_browser_esm.css`
      display: flex;
      justify-content: start;
      overflow-x: scroll;
      scrollbar-width: none;
    `};
`;
const FilterText = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)`
  font-size: ${props => (0,esm.themeGet)(props.desktopMode ? 'fontSizes.2' : 'fontSizes.0')(props)}px;
  white-space: nowrap;
  color: #8f8f8f;
`;
const LabelHeader = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  padding: ${props => (0,esm.themeGet)('space.2')(props)}px;
`;
const FastFilters = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  justify-content: ${props => props.desktopMode ? 'flex-start' : 'center'};
  align-items: center;
`;
const FilterLink = styled_components_browser_esm["default"].a`
  text-decoration: none;
  cursor: default;
  justify-content: center;
  display: flex;
`;
const FastFilterItem = styled_components_browser_esm["default"].label`
  ${(0,esm.getMediaQuery)('small')} {
    min-width: 134px;
  }
  min-width: 90px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  scroll-snap-align: center;
  border: ${(0,esm.themeGet)('borders.0')};
  border-radius: ${(0,esm.themeGet)('radii.large')};
  align-items: center;
  background: ${props => (0,esm.getBackgroundColor)('white')(props)};
  height: ${({
  height
}) => `${height}px`};
  width: fit-content;
  & > img {
    padding: ${(0,esm.themeGet)('space.2')}px
      ${props => (0,esm.themeGet)(props.desktopMode ? 'space.3' : 'space.2')}px;
    aspect-ratio: 1/1;
    max-width: 100%;
    max-height: 100%;
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/fast-filter.js







function FastFilter({
  filters = {},
  onItemClick,
  onView,
  desktopMode,
  itemHeight,
  slidesPerView
}) {
  const {
    attributeFilters
  } = filters;
  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView({
        filters
      });
    }
  }, [inView]);

  const RenderVariations = ({
    children,
    filter
  }) => {
    if (desktopMode && filter.values.length > slidesPerView) {
      return /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
        auto: false,
        showControls: false,
        showArrowControls: true,
        showPartial: false,
        showPartialNextSlide: false,
        gutter: 0,
        slidesPerView: slidesPerView,
        "data-testid": "carousel"
      }, children);
    }

    return /*#__PURE__*/react.createElement(FastFilters, {
      "data-testid": "m-carousel",
      desktopMode: desktopMode,
      gap: desktopMode ? 12 : 2
    }, children);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, attributeFilters.map((filter, idx) => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LabelHeader, null, /*#__PURE__*/react.createElement(atoms/* Heading */.X6, {
    "data-testid": "header-label",
    as: "h2",
    fontSize: desktopMode ? 18 : 14,
    color: "text.attributeLabel"
  }, filter.label)), /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    "data-testid": "filter-item-container",
    key: idx,
    desktopMode: desktopMode
  }, /*#__PURE__*/react.createElement(RenderVariations, {
    filter: filter
  }, filter == null ? void 0 : filter.values.map(item => /*#__PURE__*/react.createElement(FilterLink, {
    key: item.id,
    role: "button",
    onClick: e => onItemClick(e, item),
    href: item.url || item.href,
    "data-testid": "filter-item-link"
  }, /*#__PURE__*/react.createElement(FastFilterItem, {
    "data-testid": "filter-item-label",
    height: itemHeight,
    desktopMode: desktopMode
  }, item.filterType === 'icon' ? /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    alt: item.label,
    title: item.label,
    "data-testid": "filter-item-image",
    src: item.icon
  }) : /*#__PURE__*/react.createElement(FilterText, {
    px: 2,
    desktopMode: desktopMode,
    "data-testid": "filter-item-text"
  }, item.label)))))))));
}

 false ? 0 : void 0;
FastFilter.defaultProps = {
  filters: {},
  onItemClick: () => {},
  onView: () => {},
  slidesPerView: 5
};
/* harmony default export */ var fast_filter = (FastFilter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/index.js


/***/ }),

/***/ 63486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_delivery; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/filter-delivery.styles.js


const Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  display: flex;
  align-content: center;
  justify-content: ${({
  carousel
}) => carousel ? 'start' : 'center'};
  padding: 12px;
  overflow-x: ${({
  scrollOff
}) => scrollOff ? 'hidden' : 'scroll'};
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const DeliveryContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/filter-delivery.js






const FilterDelivery = ({
  filters,
  onChange,
  hasBorder,
  scrollOff
}) => {
  const renderIcon = slug => {
    const Icons = {
      '24c': 'DeliveryRTomorrow',
      delivery_plus_1: 'FastDelivery',
      store_pickup: 'PickupStore',
      delivery_1h: 'Delivery1h',
      delivery_24h: 'Delivery24h',
      'magalu-entregas': 'DeliveryM',
      'magalu-partner': 'Pin',
      free_shipping: 'DeliveryFree',
      today: 'ExpressDelivery',
      magalu_indica: 'FastDelivery',
      promocao_sazonal_1: 'Christmas',
      promocao_sazonal_2: 'CupomPromotion',
      promocao_sazonal_3: 'Offers',
      promocao_sazonal_4: 'Offers'
    };
    return /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: Icons[slug] || 'FastDelivery'
    });
  };

  return /*#__PURE__*/react.createElement(Container, {
    "data-testid": "delivery-filter-container",
    carousel: (filters == null ? void 0 : filters.length) > 2,
    scrollOff: scrollOff
  }, /*#__PURE__*/react.createElement(DeliveryContainer, null, filters == null ? void 0 : filters.map(({
    label,
    slug,
    selected,
    href
  }) => /*#__PURE__*/react.createElement(Chip/* default */.Z, {
    as: "a",
    type: "checkbox",
    name: "DeliveryFilter",
    startIcon: renderIcon(slug),
    onChange: item => onChange(Object.assign({}, item, {
      href,
      label,
      slug
    })),
    checked: selected,
    href: href,
    value: slug,
    key: slug,
    id: slug,
    hasBorder: hasBorder,
    textMaxWidth: '100%',
    minWidth: '135px',
    maxWidth: '150px',
    padding: '4px',
    gridGap: '6px'
  }, label))));
};

 false ? 0 : void 0;
FilterDelivery.defaultProps = {
  filters: [],
  onChange: () => {},
  scrollOff: false,
  hasBorder: false
};
/* harmony default export */ var filter_delivery = (FilterDelivery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/index.js


/***/ }),

/***/ 46212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_item_attribute; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/index.js + 2 modules
var FilterItem = __webpack_require__(1729);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js + 2 modules
var FilterItemContainer = __webpack_require__(25115);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortBySelected.js
var sortBySelected = __webpack_require__(41869);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemAttribute/filter-item-attribute.js







const filter = (input = '', items = []) => {
  return items.filter(item => {
    var _item$label, _item$label$toUpperCa;

    return (_item$label = item.label) == null ? void 0 : (_item$label$toUpperCa = _item$label.toUpperCase()) == null ? void 0 : _item$label$toUpperCa.includes(input.toUpperCase());
  });
};

const FilterItemAttribute = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    showFilterInput,
    onItemClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterItems, setFilterItems] = (0,react.useState)((0,sortBySelected/* default */.Z)(items));
  (0,react.useEffect)(() => {
    setFilterItems((0,sortBySelected/* default */.Z)(items));
    return () => setFilterItems([]);
  }, [items]);

  const handleClearInput = () => {
    setFilterItems(items);
  };

  const handleChangeFilterInput = e => {
    setFilterItems((0,sortBySelected/* default */.Z)(filter(e.target.value, items)));
  };

  return /*#__PURE__*/react.createElement(FilterItemContainer/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    label: label,
    position: position,
    fullScreen: fullScreen,
    onChangeFilterInput: handleChangeFilterInput,
    onClearInput: handleClearInput,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput
  }), /*#__PURE__*/react.createElement("ul", null, filterItems.map((item, idx) => /*#__PURE__*/react.createElement(FilterItem/* default */.Z, {
    item: item,
    key: (item == null ? void 0 : item.slug) || idx,
    onClick: onItemClick
  }))));
};

FilterItemAttribute.defaultProps = {
  label: '',
  filterSelected: '',
  items: [],
  showFilterInput: false,
  onItemClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_attribute = (FilterItemAttribute);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemAttribute/index.js


/***/ }),

/***/ 25115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_item_container; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js + 2 modules
var FilterInput = __webpack_require__(99554);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/filter-item-container.styles.js




const Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => (0,build_esm.getBackgroundColor)('lighter')(props)};
  border-bottom: 1px solid ${props => (0,build_esm.getBackgroundColor)('darker')(props)};
  border-top: 1px solid ${props => (0,build_esm.getBackgroundColor)('darker')(props)};
  padding: 14px 16px;
`;
const Content = styled_components_browser_esm["default"].div``;
const Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)``;
const FilterSelected = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  margin: 4px 0;
  color: ${props => (0,build_esm.getTextColor)('scratched')(props)};
`;
const FilterDetailTitleContainer = styled_components_browser_esm["default"].div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => (0,build_esm.getBackgroundColor)('darker')(props)};
  margin-bottom: 0.5em;
`;
const TitleContainer = styled_components_browser_esm["default"].div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/filter-item-container.js









const FilterItemContainer = _ref => {
  let {
    onClick,
    label,
    position,
    filterSelected,
    fullScreen,
    showFilterInput,
    onChangeFilterInput,
    onClearInput,
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onClick", "label", "position", "filterSelected", "fullScreen", "showFilterInput", "onChangeFilterInput", "onClearInput", "children"]);

  const [showFilterItemDetail, setShowFilterDetail] = (0,react.useState)(false);

  const handleOnClick = () => {
    setShowFilterDetail(true);
    onClick({
      label,
      position
    });
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    onClick: handleOnClick,
    "data-testid": "filter-item-container"
  }), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, {
    fontSize: 1,
    "data-testid": "filter-item-container"
  }, label), filterSelected && /*#__PURE__*/react.createElement(FilterSelected, {
    as: typeof filterSelected !== 'string' ? 'div' : 'p',
    fontSize: 0,
    "data-testid": "filter-item-selected"
  }, filterSelected)), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: "12px",
    height: "12px"
  }))), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showFilterItemDetail,
    onClickOutside: () => setShowFilterDetail(false),
    fullScreen: fullScreen
  }, /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(FilterDetailTitleContainer, null, /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(esm/* ArrowBack */.xhZ, {
    color: "#8c8c8c",
    "data-testid": "close-filter-detail",
    role: "button",
    title: "Fechar filtro",
    onClick: () => setShowFilterDetail(false)
  })), /*#__PURE__*/react.createElement(TitleContainer, null, /*#__PURE__*/react.createElement(Title, {
    fontSize: 1,
    textAlign: "center",
    fontWeight: "500"
  }, label))), /*#__PURE__*/react.createElement("div", null, showFilterInput && /*#__PURE__*/react.createElement(FilterInput/* default */.Z, {
    m: '20px',
    onChange: onChangeFilterInput,
    onClearInput: onClearInput,
    label: label
  })), children))));
};

FilterItemContainer.defaultProps = {
  filterSelected: '',
  onClick: () => ({}),
  fullScreen: false
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_container = (FilterItemContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js


/***/ }),

/***/ 33723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_item_price; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var esm = __webpack_require__(87879);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js + 2 modules
var FilterItemContainer = __webpack_require__(25115);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemPrice/filter-item-price.js








const FilterItemPrice = _ref => {
  let {
    fullScreen,
    label,
    position,
    onApply,
    min,
    max,
    selectedMin,
    selectedMax,
    item
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "onApply", "min", "max", "selectedMin", "selectedMax", "item"]);

  return /*#__PURE__*/react.createElement(FilterItemContainer/* default */.Z, (0,esm_extends/* default */.Z)({
    id: "filter-item-price-container",
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: selectedMin || selectedMax ? `${(0,esm/* currencyFormatter */.oB)({
      value: selectedMin
    })} - ${(0,esm/* currencyFormatter */.oB)({
      value: selectedMax
    })}` : undefined
  }, props), /*#__PURE__*/react.createElement(molecules/* PriceRange */.MS, {
    min: min,
    max: max,
    initialMin: selectedMin,
    initialMax: selectedMax,
    onApply: onApply,
    item: item
  }));
};

FilterItemPrice.defaultProps = {
  onApply: () => {},
  onClick: () => {},
  item: {}
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_price = (FilterItemPrice);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemPrice/index.js


/***/ }),

/***/ 18136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_item_review; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js + 2 modules
var FilterItemContainer = __webpack_require__(25115);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortDescByValue.js
var sortDescByValue = __webpack_require__(82260);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemReview/filter-item-review.js








const FilterItemReview = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    onItemClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterRating, setFilterRating] = (0,react.useState)((0,sortDescByValue/* default */.Z)(items));
  (0,react.useEffect)(() => {
    setFilterRating(items);
    return () => setFilterRating({});
  }, [items]);
  return /*#__PURE__*/react.createElement(FilterItemContainer/* default */.Z, (0,esm_extends/* default */.Z)({
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: filterSelected && Object.keys(filterSelected).length ? /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
      min: 0,
      max: 5,
      score: filterSelected == null ? void 0 : filterSelected.value,
      label: filterSelected == null ? void 0 : filterSelected.hint,
      format: "label",
      fontSize: "14px",
      width: "20px",
      height: "20px"
    }) : undefined
  }, props), filterRating.map((item, idx) => /*#__PURE__*/react.createElement("ul", {
    key: (item == null ? void 0 : item.slug) || idx
  }, /*#__PURE__*/react.createElement(molecules/* FilterItem */.L2, {
    onClick: onItemClick,
    item: item
  }, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    min: 0,
    max: 5,
    score: item == null ? void 0 : item.value,
    label: item == null ? void 0 : item.hint,
    format: "label",
    fontSize: "14px",
    width: "20px",
    height: "20px",
    "data-testid": "review-item"
  })))));
};

FilterItemReview.defaultProps = {
  filterSelected: [],
  items: [],
  showFilterInput: false,
  onItemClick: () => {},
  onClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_review = (FilterItemReview);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemReview/index.js


/***/ }),

/***/ 18367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeaderLinks_HeaderLinks; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/header-links.styles.js



const mobileStyle = {
  height: 'auto',
  fontSize: 0,
  flexWrap: 'no-wrap',
  mt: 0,
  overflow: 'auto',
  px: '9px',
  pb: '5px'
};
const desktopStyle = {
  height: '16px',
  fontSize: 1,
  flexWrap: 'wrap',
  mt: 1,
  overflow: 'hidden'
};
const HeaderLinksContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(props => Object.assign({
  bg: 'background.primary'
}, props.isMobile ? Object.assign({}, mobileStyle) : Object.assign({}, desktopStyle), props))`
  white-space: pre;
  line-height: ${props => (0,esm.themeGet)('lineHeights.plus')(props)}px;

  a {
    font-size: inherit;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/HeaderLinks.js









const HeaderLinks = _ref => {
  let {
    data,
    onClick,
    isMobile,
    isRendered
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "onClick", "isMobile", "isRendered"]);

  const {
    links,
    title
  } = data;
  if ((links == null ? void 0 : links.length) >= 1 && title) return /*#__PURE__*/react.createElement(HeaderLinksContainer, (0,esm_extends/* default */.Z)({
    display: isRendered ? 'flex' : 'none',
    "data-testid": "header-links-list",
    isMobile: isMobile
  }, props, {
    color: "text.lightest"
  }), /*#__PURE__*/react.createElement(Text/* default */.Z, {
    color: "text.lightest"
  }, `${title}: `), links == null ? void 0 : links.map((link, index) => {
    const pipe = index !== 0 && /*#__PURE__*/react.createElement("span", null, " | ");
    return /*#__PURE__*/react.createElement(react.Fragment, null, pipe, /*#__PURE__*/react.createElement(Link/* default */.Z, {
      "data-testid": "header-link",
      key: link.value,
      href: link.href,
      onClick: e => onClick(e, link),
      hover: false,
      color: "text.lightest"
    }, (0,utils/* capitalize */.kC)(link.value)));
  }));
  return null;
};

 false ? 0 : void 0;
HeaderLinks.defaultProps = {
  data: {
    links: [],
    title: ''
  },
  onClick: () => {},
  isMobile: false,
  isRendered: true
};
/* harmony default export */ var HeaderLinks_HeaderLinks = (HeaderLinks);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/index.js


/***/ }),

/***/ 66608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ import_taxes; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var esm = __webpack_require__(87879);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/dialog.styles.js
var dialog_styles = __webpack_require__(37270);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-taxes.styles.js




const LabelTitle = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)`
  color: ${props => (0,build_esm.getTextColor)('scratched')(props)};
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
  margin-bottom: 5px;
`;
const Label = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)`
  color: ${props => (0,build_esm.getTextColor)('scratched')(props)};
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
`;
const Disclaimer = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs({
  fontSize: 3
})`
  line-height: normal;
  font-weight: normal;
  color: ${props => (0,build_esm.themeGet)('colors.greyishBrown')(props)};
`;
const ImportText = styled_components_browser_esm["default"].div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: normal;
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.3')(props)}px;

  color: ${props => (0,build_esm.themeGet)('colors.greyishBrown')(props)};
  line-height: 18.7px;

  b {
    font-weight: 500;
  }
`;
const ImportButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)`
  border-radius: 12px;
  padding: 11px 100px;
`;
const Title = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)`
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
  color: ${props => (0,build_esm.getPaletteColor)('text.scratched')(props)};
  line-height: 1.25;
`;
const BreakingLine = styled_components_browser_esm["default"].br``;
const DialogContainer = (0,styled_components_browser_esm["default"])(atoms/* Dialog */.Vq).attrs({
  titleStyle: {
    fontSize: '22px',
    color: '#424A52',
    fontWeight: 700
  }
})`
  max-width: 724px;
  overflow-x: hidden;
`;
const DialogHorizontalRule = (0,styled_components_browser_esm["default"])(dialog_styles/* HorizontalRule */.bo)`
  height: 1px;
  max-width: 724px;
  transform: translateX(-16px);
  margin: 24px 0 18px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/content-box.js








const ContentBox = _ref => {
  let {
    onLinkClick,
    isIncludeTaxes,
    totalValueImportTax,
    totalValueICMS
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onLinkClick", "isIncludeTaxes", "totalValueImportTax", "totalValueICMS"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, (0,esm_extends/* default */.Z)({
    "data-testid": "content-box"
  }, props), isIncludeTaxes && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LabelTitle, {
    "data-testid": "titletaxeslabel"
  }, "+ Imposto de importa\xE7\xE3o ", (0,esm/* currencyFormatter */.oB)({
    value: totalValueImportTax
  }), " e ICMS ", (0,esm/* currencyFormatter */.oB)({
    value: totalValueICMS
  }), "."), /*#__PURE__*/react.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Os impostos s\xE3o calculados de acordo com o ", /*#__PURE__*/react.createElement(BreakingLine, null), "Remessa Conforme.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais"))), !isIncludeTaxes && /*#__PURE__*/react.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Impostos de importa\xE7\xE3o ser\xE3o adicionados ao seguir ", /*#__PURE__*/react.createElement(BreakingLine, null), "com a compra.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  onLinkClick: undefined,
  isIncludeTaxes: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-details.js






const ImportDetails = ({
  closeDetails,
  isMobile
}) => {
  return /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    "data-testid": "detail-text"
  }, /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 16
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: isMobile ? 'column' : 'row'
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(stereo_ui_icons_build_esm/* ShipmentInAccordance */.qGg, {
    mr: 16,
    width: 66,
    height: 67
  })), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(Disclaimer, null, "[PRODUTO INTERNACIONAL/COMPRA INTERNACIONAL] Toda mercadoria proveniente do exterior (importada) deve ser objeto de declara\xE7\xE3o de importa\xE7\xE3o e est\xE1 sujeita a tributos federal e estadual."))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(ImportText, null, /*#__PURE__*/react.createElement("span", null, "Com o Remessa Conforme, o programa do governo brasileiro que simplifica o processo de importa\xE7\xE3o, voc\xEA sabe de forma clara o que pagar:"), /*#__PURE__*/react.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/react.createElement("b", null, "at\xE9 50 d\xF3lares"), ", voc\xEA paga 20% de taxa de importa\xE7\xE3o e o ICMS*, sem taxas extras na alf\xE2ndega."), /*#__PURE__*/react.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/react.createElement("b", null, "acima de 50,01 d\xF3lares"), ", a taxa de importa\xE7\xE3o \xE9 de 60%, com um desconto de 20 d\xF3lares, al\xE9m do ICMS*. E n\xE3o h\xE1 taxas extras na alf\xE2ndega."), /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("b", null, "*ICMS:"), " Imposto estadual sobre a circula\xE7\xE3o de produtos e servi\xE7os no Brasil. Al\xEDquota de 17% ou 20% calculada automaticamente de acordo com o estado de destino da mercadoria. Em caso de d\xFAvidas sobre a al\xEDquota consulte a Secretaria da Fazenda do seu estado.")))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(DialogHorizontalRule, {
    ruleSize: 1,
    bg: "border.light"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    justifyContent: "center"
  }, /*#__PURE__*/react.createElement(ImportButton, {
    onClick: closeDetails
  }, "Entendi"))));
};

 false ? 0 : void 0;
ImportDetails.defaultProps = {
  closeDetails: () => {},
  isMobile: false
};
/* harmony default export */ var import_details = (ImportDetails);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-taxes.js











const ImportTaxes = _ref => {
  let {
    product,
    onDetailsOpen,
    onDetailsClose,
    isIncludeTaxes,
    isMobile
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["product", "onDetailsOpen", "onDetailsClose", "isIncludeTaxes", "isMobile"]);

  const [showDetails, setShowDetails] = (0,react.useState)(false);
  const showInternationalPurchase = (0,utils/* isInternationalPrice */.xx)(product == null ? void 0 : product.price);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (!showInternationalPurchase) return null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(TagInternational/* default */.Z, {
    variant: "small"
  }), /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    onLinkClick: openDetails,
    isIncludeTaxes: isIncludeTaxes
  }, props)), isMobile && /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/react.createElement(Sidebar/* SidebarHeader */.$, {
    label: "Compra Internacional",
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a página do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/react.createElement(import_details, {
    isMobile: true,
    closeDetails: closeDetails
  })), !isMobile && /*#__PURE__*/react.createElement(DialogContainer, {
    visible: showDetails,
    onClickOutside: closeDetails,
    position: "center",
    showHorizontalRule: true,
    title: "Compra Internacional",
    showClose: true
  }, /*#__PURE__*/react.createElement(import_details, {
    closeDetails: closeDetails
  })));
};

 false ? 0 : void 0;
ImportTaxes.defaultProps = {
  product: {},
  isMobile: false,
  isIncludeTaxes: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
/* harmony default export */ var import_taxes = (ImportTaxes);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/index.js


/***/ }),

/***/ 76228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ inline_filter; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/InlineFilter/inline-filter.styles.js




const InlineFilterContainer = styled_components_browser_esm["default"].div`
  width: 100%;
  grid-column: 1 / -1;
  padding: ${props => (0,esm.themeGet)('space.2')(props)}px;
  background: ${props => (0,esm.getBackgroundColor)('background')(props)};

  ${({
  desktopMode
}) => !desktopMode && styled_components_browser_esm.css`
      display: flex;
      flex-direction: column;
    `};
`;
const FilterText = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)`
  font-size: ${props => (0,esm.themeGet)(props.desktopMode ? 'fontSizes.2' : 'fontSizes.0')(props)}px;
  white-space: nowrap;
  color: #8f8f8f;
`;
const LabelHeader = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  padding: ${props => (0,esm.themeGet)('space.2')(props)}px;
`;
const FastFilters = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const FilterLink = styled_components_browser_esm["default"].a`
  text-decoration: none;
  cursor: default;
  justify-content: center;
  display: flex;
`;
const FastFilterItem = styled_components_browser_esm["default"].label`
  ${(0,esm.getMediaQuery)('small')} {
    min-width: 134px;
  }
  min-width: 90px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  scroll-snap-align: center;
  border: ${(0,esm.themeGet)('borders.0')};
  border-radius: ${(0,esm.themeGet)('radii.large')};
  align-items: center;
  background: ${props => (0,esm.getBackgroundColor)('white')(props)};
  height: ${({
  height
}) => `${height}px`};
  width: fit-content;
  & > img {
    padding: ${(0,esm.themeGet)('space.2')}px
      ${props => (0,esm.themeGet)(props.desktopMode ? 'space.3' : 'space.2')}px;
    aspect-ratio: 1/1;
    max-width: 100%;
    max-height: 100%;
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/InlineFilter/inline-filter.js







function InlineFilter({
  filter = {},
  onItemClick = () => {},
  onView = () => {},
  desktopMode,
  itemHeight,
  slidesPerView = 5
}) {
  var _filter$values2;

  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView({
        filter
      });
    }
  }, [inView]);

  const RenderVariations = ({
    children
  }) => {
    var _filter$values;

    if (desktopMode && ((_filter$values = filter.values) == null ? void 0 : _filter$values.length) > slidesPerView) {
      return /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
        auto: false,
        showControls: false,
        showArrowControls: true,
        showPartial: false,
        showPartialNextSlide: false,
        gutter: 0,
        slidesPerView: slidesPerView,
        "data-testid": "inline-filter-carousel"
      }, children);
    }

    return /*#__PURE__*/react.createElement(FastFilters, {
      "data-testid": "inline-filter-list",
      desktopMode: desktopMode,
      gap: desktopMode ? 12 : 2
    }, children);
  };

  if (!((_filter$values2 = filter.values) != null && _filter$values2.length)) {
    return null;
  }

  return /*#__PURE__*/react.createElement(InlineFilterContainer, {
    ref: ref,
    "data-testid": "inline-filter-container",
    desktopMode: desktopMode
  }, /*#__PURE__*/react.createElement(LabelHeader, null, /*#__PURE__*/react.createElement(atoms/* Heading */.X6, {
    "data-testid": "inline-filter-label",
    as: "h2",
    fontSize: desktopMode ? 18 : 14,
    color: "text.attributeLabel"
  }, filter.label)), /*#__PURE__*/react.createElement(RenderVariations, null, filter.values.map(item => /*#__PURE__*/react.createElement(FilterLink, {
    key: item.id,
    role: "button",
    onClick: e => onItemClick(e, item),
    href: item.url || item.href,
    "data-testid": "inline-filter-link"
  }, /*#__PURE__*/react.createElement(FastFilterItem, {
    "data-testid": "inline-filter-item",
    height: itemHeight,
    desktopMode: desktopMode
  }, item.filterType === 'icon' ? /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    alt: item.label,
    title: item.label,
    "data-testid": "inline-filter-image",
    src: item.icon
  }) : /*#__PURE__*/react.createElement(FilterText, {
    px: 2,
    desktopMode: desktopMode,
    "data-testid": "inline-filter-text"
  }, item.label))))));
}

 false ? 0 : void 0;
InlineFilter.defaultProps = {
  filter: {},
  onItemClick: () => {},
  onView: () => {},
  slidesPerView: 5
};
/* harmony default export */ var inline_filter = (InlineFilter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/InlineFilter/index.js


/***/ }),

/***/ 75057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ letMeKnow; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/fullNameMask.js
var fullNameMask = __webpack_require__(15312);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/emailMask.js
var emailMask = __webpack_require__(13111);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/letMeKnow.styles.js




const Title = (0,styled_components_browser_esm["default"])(Heading/* default */.Z).attrs({
  fontSize: 5,
  fontWeight: 'light'
})``;
const Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs({
  fontSize: [0, 1, 2, 2],
  display: 'contents',
  color: 'text.light',
  mY: 3
})``;
const InputLabel = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs({
  mt: 3,
  mb: 1
})``;
const ErrorMessage = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs({
  color: 'error',
  mt: 1
})``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/letMeKnow.js














function LetMeKnow({
  errorEmail,
  errorName,
  labelEmail,
  labelName,
  labelNewsletter,
  noticeMeLabel,
  noticeMeLink,
  onSubmit,
  placeholderEmail,
  placeholderName,
  subtitle,
  textSubmitButton,
  title
}) {
  const [newsletter, setNewsletter] = (0,react.useState)(true);
  const [fullName, setFullName] = (0,react.useState)('');
  const [email, setEmail] = (0,react.useState)('');
  const [errors, setErrors] = (0,react.useState)({});
  const validateFullName = react.useCallback(() => {
    const fullNameError = !(0,fullNameMask/* default */.Z)(fullName) ? {
      fullName: errorName
    } : undefined;
    setErrors(_ref => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullName"]);

      return Object.assign({}, errs, fullNameError);
    });
    return fullNameError;
  }, [fullName]);
  const validateEmail = react.useCallback(_email => {
    const emailError = !(0,emailMask/* default */.Z)(_email) ? {
      email: errorEmail
    } : undefined;
    setErrors(_ref2 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["email"]);

      return Object.assign({}, errs, emailError);
    });
    return emailError;
  }, [email]);
  const clearForm = (0,react.useCallback)(() => {
    setFullName('');
    setEmail('');
    setNewsletter(true);
  }, [fullName, email]);

  const handleSubmit = e => {
    const errs = Object.assign({}, validateFullName(fullName), validateEmail(email));

    if (!Object.entries(errs).length) {
      onSubmit({
        fullName,
        email,
        newsletter
      }, clearForm);
    }

    e.preventDefault();
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: "baseline",
    gap: "2",
    mb: "3"
  }, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "let-me-know-title"
  }, title), /*#__PURE__*/react.createElement(Link/* default */.Z, {
    href: noticeMeLink,
    target: "_blank",
    underline: true,
    color: "text.light",
    fontSize: [0, 1, 2, 2]
  }, noticeMeLabel)), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "let-me-know-description"
  }, subtitle), /*#__PURE__*/react.createElement("form", null, /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-name"
  }, labelName), /*#__PURE__*/react.createElement(Input/* default */.Z, {
    "data-testid": "let-me-know-input-name",
    placeholder: placeholderName,
    hasError: !!errors.fullName,
    value: fullName,
    onChange: e => setFullName(e.target.value),
    onFocus: () => setErrors(_ref3 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["fullName"]);

      return errs;
    }),
    onBlur: e => validateFullName(e.target.value)
  }), /*#__PURE__*/react.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-name"
  }, errors.fullName), /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-email"
  }, labelEmail), /*#__PURE__*/react.createElement(Input/* default */.Z, {
    "data-testid": "let-me-know-input-email",
    placeholder: placeholderEmail,
    type: "email",
    hasError: !!errors.email,
    value: email,
    onChange: e => setEmail(e.target.value),
    onFocus: () => setErrors(_ref4 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["email"]);

      return errs;
    }),
    onBlur: e => validateEmail(e.target.value)
  }), /*#__PURE__*/react.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-email"
  }, errors.email)), /*#__PURE__*/react.createElement(Box/* default */.Z, {
    mt: 15
  }, /*#__PURE__*/react.createElement(Checkbox/* default */.Z, {
    as: Text/* default */.Z,
    fontSize: [1, 2],
    checked: newsletter,
    onChange: e => setNewsletter(e.target.checked)
  }, labelNewsletter)), /*#__PURE__*/react.createElement(Box/* default */.Z, {
    mt: 15
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    "data-testid": "let-me-know-submit",
    full: true,
    onClick: handleSubmit
  }, textSubmitButton)));
}

LetMeKnow.defaultProps = {
  errorEmail: 'Insira o e-mail corretamente.',
  errorName: 'Insira o nome completo corretamente.',
  labelEmail: 'E-mail',
  labelName: 'Nome',
  labelNewsletter: 'Quero receber ofertas e conteúdos por e-mail',
  noticeMeLabel: 'Ver produtos similares',
  onSubmit: undefined,
  placeholderEmail: 'Digite seu e-mail',
  placeholderName: 'Digite seu nome',
  subtitle: 'Avise-me quando estiver disponível',
  textSubmitButton: 'Avise-me',
  title: 'Não disponível'
};
 false ? 0 : void 0;
/* harmony default export */ var letMeKnow = (LetMeKnow);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/index.js


/***/ }),

/***/ 57669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ links_menu; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/links-menu.styles.js





const NavMenuContainer = styled_components_browser_esm["default"].nav.attrs(props => Object.assign({
  bg: 'background.primary'
}, props))`
  text-align: left;

  ${build_esm.color}
`;
const NavMenu = styled_components_browser_esm["default"].ul.attrs(props => Object.assign({
  my: 0,
  pl: 0
}, props))`
  display: flex;
  align-items: center;
  line-height: 45px;
  list-style: none;
  white-space: nowrap;
  justify-content: space-between;

  ${index_esm.space}
`;
const links_menu_styles_Link = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(props => Object.assign({
  color: 'text.white',
  px: '10px',
  underlineOnHover: false
}, props))`
  ${build_esm.color}
`;
const NavSubmenu = styled_components_browser_esm["default"].div`
  position: absolute;
  background-color: ${props => (0,build_esm.getBackgroundColor)('white')(props)};
  z-index: ${props => (0,build_esm.themeGet)('zIndices.4')(props)};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  opacity: ${props => props.show ? 1 : 0};
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  transition: opacity 0;
`;
const NavMenuItem = styled_components_browser_esm["default"].li`
  display: inline-block;
  position: relative;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  z-index: ${props => props.selected ? (0,build_esm.themeGet)('zIndices.1')(props) : 'auto'};
  background-color: ${props => props.selected ? (0,build_esm.getBackgroundColor)('white')(props) : 'transparent'};

  border-top-left-radius: ${props => props.selected ? '6px' : '0'};
  border-top-right-radius: ${props => props.selected ? '6px' : '0'};

  &:hover path {
    fill: ${props => props.colorOnHover || (0,build_esm.getTextColor)('base')(props)};
  }

  &:hover > div > a {
    color: ${props => props.colorOnHover || (0,build_esm.getTextColor)('base')(props)};
  }

  ${props => props.selected && styled_components_browser_esm.css`
      & path {
        fill: ${props.colorOnHover || (0,build_esm.getTextColor)('base')(props)} !important;
      }

      > div > a {
        color: ${props.colorOnHover || (0,build_esm.getTextColor)('base')(props)} !important;
      }
    `}
`;
const MenuOverlay = styled_components_browser_esm["default"].div`
  background: rgba(0, 0, 0, 0.6);
  animation: ${utils/* fadeIn */.Ji} 0.2s linear;

  position: fixed;
  z-index: ${props => (0,build_esm.themeGet)('zIndices.0')(props)};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${props => props.show ? styled_components_browser_esm.css`
          display: block;
        ` : styled_components_browser_esm.css`
          display: none;
        `};
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuContent/index.js + 5 modules
var MenuContent = __webpack_require__(48919);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/links-menu.js







const hasSubMenuContent = menuItem => {
  const {
    banner,
    subcategoriesList
  } = menuItem || {};
  const {
    component
  } = banner || {};
  const {
    props
  } = component || {};
  const {
    static: staticProps
  } = props || {};
  const hasBannerPath = Boolean(staticProps == null ? void 0 : staticProps.path);
  const hasBannerSlot = Boolean(staticProps == null ? void 0 : staticProps.slot);
  const hasSubcategories = Array.isArray(subcategoriesList) && subcategoriesList.length > 0;
  return hasBannerPath || hasBannerSlot || hasSubcategories;
};

const LinksMenu = ({
  data,
  enableHoverDelay,
  onMenuItemClick,
  onHoverMenuItem,
  onClickMenuItem
}) => {
  const {
    categoryList,
    specialLinks,
    externalLinks,
    allCategories
  } = data;
  const {
    orderBy = [],
    list = [],
    show
  } = categoryList;
  const categList = (0,utils/* sortCategoriesList */.IC)(list, orderBy);
  const categItems = categList.slice(0, show || orderBy.length);
  const ctnMenuRef = (0,react.useRef)(null);
  const menuItemRefs = {};
  const subMenuItemRefs = {};
  const [submenuMargin, setSubmenuMargin] = (0,react.useState)(0);
  const [selectedSubmenu, setSelectSubmenu] = (0,react.useState)(null);
  const [submenuOpenOrigin, setSubmenuOpenOrigin] = (0,react.useState)(null);
  (0,utils/* useHideOverflownElements */.O)(menuItemRefs, ctnMenuRef, 'inline-block');

  const onItemMouseOver = key => {
    var _subMenuItemRefs$key;

    const subMenuEl = (_subMenuItemRefs$key = subMenuItemRefs[key]) == null ? void 0 : _subMenuItemRefs$key.current;

    if (subMenuEl) {
      subMenuEl.style.display = 'block';
      const subMenuWidth = subMenuEl.clientWidth;
      const itemOffset = menuItemRefs[key].current.offsetLeft;
      const headerWidth = ctnMenuRef.current.offsetWidth + ctnMenuRef.current.offsetLeft;
      const diff = itemOffset + subMenuWidth - headerWidth;
      setSubmenuMargin(diff >= 0 ? -diff : 0);
      subMenuEl.style.display = null;
    }
  };

  const handleSubMenu = (action, menu, key, origin = 'mouse') => {
    const shouldHandleSubMenu = hasSubMenuContent(menu);
    if (!shouldHandleSubMenu) return;

    if (action === 'open' && enableHoverDelay) {
      onItemMouseOver(key);
      setSelectSubmenu(key);
      setSubmenuOpenOrigin(origin);
    } else if (action === 'close') {
      setSelectSubmenu(null);
      setSubmenuOpenOrigin(null);
    }
  };

  const handleKeyDown = (e, menu, key) => {
    if (e.currentTarget !== e.target) return;
    const hasSubMenu = hasSubMenuContent(menu);

    if (e.key === 'Enter') {
      if (hasSubMenu) {
        handleSubMenu('open', menu, key, 'keyboard');
      } else {
        return;
      }
    }

    if (e.key === 'Escape' && selectedSubmenu === key) {
      var _menuItemRefs$key;

      e.preventDefault();
      handleSubMenu('close', menu, key);

      if ((_menuItemRefs$key = menuItemRefs[key]) != null && _menuItemRefs$key.current) {
        menuItemRefs[key].current.focus();
      }
    }
  };

  const renderSubmenu = (submenuData = {}, key) => {
    const handleSubmenuBlur = e => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        handleSubMenu('close', submenuData, key);
      }
    };

    return /*#__PURE__*/react.createElement(NavSubmenu, {
      marginLeft: submenuMargin,
      show: selectedSubmenu === key,
      "data-testid": "nav-submenu",
      ref: subMenuItemRefs[key],
      onBlur: handleSubmenuBlur,
      tabIndex: -1,
      onKeyDown: e => {
        if (e.key === 'Escape' && selectedSubmenu === key) {
          var _menuItemRefs$key2;

          e.preventDefault();
          handleSubMenu('close', submenuData, key);

          if ((_menuItemRefs$key2 = menuItemRefs[key]) != null && _menuItemRefs$key2.current) {
            menuItemRefs[key].current.focus();
          }
        }
      }
    }, /*#__PURE__*/react.createElement(MenuContent/* default */.Z, {
      data: submenuData,
      onMenuItemClick: (e, link, menuType) => {
        onMenuItemClick(e, link, submenuData.label, menuType);
        handleSubMenu('close', submenuData, key);
      }
    }));
  };

  const renderMenu = ({
    menuType,
    index,
    menu,
    icon,
    chevronDown = false
  }) => {
    const {
      color,
      label,
      url
    } = menu;
    const key = `${menuType}-item-${index}`;
    menuItemRefs[key] = (0,react.useRef)(null);
    subMenuItemRefs[key] = (0,react.useRef)(null);
    const hasSubMenu = hasSubMenuContent(menu);
    return /*#__PURE__*/react.createElement(NavMenuItem, {
      tabIndex: 0,
      selected: hasSubMenu && selectedSubmenu === key,
      "data-testid": "link-menu-item",
      key: key,
      colorOnHover: hasSubMenu ? '' : color,
      onMouseEnter: event => {
        event.stopPropagation();

        if (submenuOpenOrigin !== 'keyboard') {
          handleSubMenu('open', menu, key, 'mouse');
        }

        onHoverMenuItem(menu);
      },
      onMouseLeave: () => {
        if (submenuOpenOrigin === 'mouse') {
          handleSubMenu('close', menu, key);
        }
      },
      onKeyDown: e => handleKeyDown(e, menu, key),
      ref: menuItemRefs[key]
    }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      mx: "2px",
      justifyContent: "center",
      alignItems: "center"
    }, icon && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: icon,
      "data-testid": `link-icon-${index}`,
      color: "text.lightest"
    }), /*#__PURE__*/react.createElement(links_menu_styles_Link, {
      href: url,
      tabIndex: 0,
      onClick: event => {
        event.stopPropagation();
        onClickMenuItem(label);
      },
      onKeyDown: e => {
        if ((e.key === 'Enter' || e.keyCode === 13) && hasSubMenuContent(menu)) {
          e.preventDefault();
          handleSubMenu('open', menu, key, 'keyboard');
        }
      }
    }, label), chevronDown && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "ChevronDown",
      color: "text.lightest"
    })), renderSubmenu(menu, key));
  };

  return /*#__PURE__*/react.createElement(NavMenuContainer, {
    "data-testid": "links-menu",
    ref: ctnMenuRef
  }, /*#__PURE__*/react.createElement(NavMenu, null, renderMenu({
    menuType: 'main',
    index: 0,
    icon: 'Burger',
    menu: allCategories,
    chevronDown: true
  }), specialLinks.map((special, index) => renderMenu({
    menuType: 'special',
    index,
    menu: special
  })), categItems.map((category, index) => renderMenu({
    menuType: 'category',
    index,
    menu: category
  })), externalLinks.map((external, index) => renderMenu({
    menuType: 'external',
    index,
    menu: external,
    icon: external.id
  }))), /*#__PURE__*/react.createElement(MenuOverlay, {
    "data-testid": "menu-overlay",
    show: !!selectedSubmenu
  }));
};

 false ? 0 : void 0;
LinksMenu.defaultProps = {
  data: {
    categoryList: {},
    specialLinks: [],
    externalLinks: [],
    allCategories: {}
  },
  enableHoverDelay: true
};
/* harmony default export */ var links_menu = (LinksMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/index.js


/***/ }),

/***/ 99075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CommissionBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/loyalty-commission-styles.js


const Content = styled_components_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  text-align: center;
`;
const Title = styled_components_browser_esm["default"].h2`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.4')(props)}px;
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.fontSize')(props)};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.medium')(props)};
  color: ${props => props.color};
  margin: 10px;
`;
const Description = styled_components_browser_esm["default"].p`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.2')(props)}px;
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.display')(props)};
  color: ${props => (0,build_esm.getTextColor)('base')(props)};
  margin: 15px 0;
  width: 80%;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/loyalty-commission.js







function CommissionBadge({
  label,
  description,
  value,
  productUrl,
  attributes: {
    color,
    icon,
    textColor
  }
}) {
  const icons = {
    coin: 'Coin',
    lightning: 'Lightning'
  };
  const iconName = icons[icon] || 'Coin';
  const [buttonActive, setButtonActive] = (0,react.useState)(false);
  const [isModalOpen, setModalOpen] = (0,react.useState)(false);

  const toggleModal = e => {
    e.stopPropagation();
    e.preventDefault();
    setModalOpen(!isModalOpen);
  };

  const onClick = link => {
    if (buttonActive) return false;
    setButtonActive(true);
    (0,utils/* copyToClipboard */.vQ)(link);
    return setTimeout(() => setButtonActive(false), 3000);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(molecules/* Loyalty */.mY, {
    hasInfo: true,
    onClick: toggleModal,
    color: color,
    icon: iconName,
    textColor: textColor,
    value: value
  }), /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: isModalOpen,
    onClickOutside: toggleModal,
    position: "center",
    showClose: true,
    type: "alert"
  }, /*#__PURE__*/react.createElement(Content, {
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
    }
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: iconName,
    "data-testid": "loyalty-commission-icon",
    width: "25px",
    height: "25px",
    color: color
  }), /*#__PURE__*/react.createElement(Title, {
    id: "loyaltyDialogTitle",
    color: color
  }, label)), /*#__PURE__*/react.createElement(molecules/* Loyalty */.mY, {
    value: value,
    color: color,
    Icon: esm/* Icon */.JO$,
    textColor: textColor
  }), /*#__PURE__*/react.createElement(Description, {
    id: "loyaltyDialogDesc"
  }, description), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    rounded: true,
    variation: buttonActive ? null : 'outline',
    full: true,
    onClick: () => onClick(productUrl),
    "data-testid": "loyalty-commission-button"
  }, buttonActive ? 'Copiado' : 'Copiar Link'))));
}
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js


/***/ }),

/***/ 60857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MediaGallery_MediaGallery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaThumbnails.styles.js


const MiniatureItem = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(props => ({
  borderWidth: props.selected ? 2 : 1,
  borderColor: props.selected ? 'blue' : 'whisper',
  borderStyle: 'solid',
  borderRadius: 'default',
  padding: 2,
  width: props.smallThumbnails ? '84px' : '110px',
  height: props.smallThumbnails ? '66px' : '110px',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative'
}))`
  & img {
    height: ${props => props.smallThumbnails ? '70px' : '90px'};
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaThumbnails.js









const MediaThumbnails = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "onImageClick", "onImageChange", "onAudioClick", "onVideoClick", "showMedia", "showMoreTooltip", "smallThumbnails", "preload"]);

  const [imageSelected, setImageSelected] = (0,react.useState)({
    image: images[0],
    index: 0
  });

  const handleImageClick = index => {
    onImageClick(index);
  };

  (0,react.useEffect)(() => {
    setImageSelected({
      image: images[0],
      index: 0
    });
  }, [images]);
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    columnGap: 4,
    maxHeight: 614,
    "data-testid": "media-gallery"
  }, props), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    rowGap: 3,
    flexDirection: "column",
    width: "fit-content"
  }, images.slice(0, images.length > 5 ? 4 : images.length).map((image, index) => /*#__PURE__*/react.createElement(MiniatureItem, {
    key: `gallery-img-${index}`,
    selected: index === imageSelected.index,
    smallThumbnails: smallThumbnails
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    src: image,
    width: 90,
    height: 90,
    onClick: () => setImageSelected({
      image,
      index
    }),
    onMouseOver: () => setImageSelected({
      image,
      index
    })
  }))), images.length > 5 && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    "data-testid": "media-gallery-image-more",
    fontSize: 5,
    fontWeight: "bold",
    borderRadius: "default",
    width: smallThumbnails ? '84px' : '110px',
    height: smallThumbnails ? '66px' : '110px',
    title: showMoreTooltip,
    alignItems: "center",
    justifyContent: "center",
    bg: "background.base",
    color: "text.base",
    cursor: "pointer",
    onClick: () => onImageClick(4)
  }, "+ ", images.length - 4)), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flex: 1,
    maxHeight: 614,
    position: "relative"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    "data-testid": "image-selected-thumbnail",
    src: imageSelected.image,
    maxHeight: imgMaxHeight,
    width: imgWidth,
    height: imgHeight,
    alt: alt,
    title: title,
    lazy: !preload || imageSelected.index !== 0,
    onClick: () => handleImageClick(imageSelected.index),
    cursor: "pointer"
  }), showMedia && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    gap: 2,
    position: "absolute",
    bottom: 0,
    left: 0,
    "data-testid": "media-gallery-icons"
  }, !!video && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "VideoCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-video-icon",
    onClick: onVideoClick
  }), !!audio && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "PodcastCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-audio-icon",
    onClick: onAudioClick
  }))));
};

 false ? 0 : void 0;
MediaThumbnails.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 600,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  alt: '',
  title: '',
  showMoreTooltip: '',
  smallThumbnails: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaThumbnails = (MediaThumbnails);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaCarousel.js








const MediaCarousel = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    counterSeparator,
    showCounter,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    lazy,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showMedia", "lazy", "preload"]);

  const [imagesCounter, setCounter] = (0,react.useState)(1);
  const [dialogVisible, setDialogVisible] = (0,react.useState)();
  const mediaTypeHandler = {
    audio: onAudioClick,
    video: onVideoClick
  };
  const mediaTypeRender = {
    video: /*#__PURE__*/react.createElement(atoms/* Embed */.cx, {
      "data-testid": "media-embed",
      src: video
    }),
    audio: /*#__PURE__*/react.createElement("audio", {
      "data-testid": "media-audio",
      controls: true,
      src: audio
    })
  };

  const toggleDialog = type => {
    const nextType = typeof type === 'string' && ['video', 'audio'].includes(type) ? type : null;
    setDialogVisible(nextType);
  };

  const handleMediaClick = type => {
    const mediaHandler = mediaTypeHandler[type];
    mediaHandler();
    toggleDialog(type);
  };

  const handleImageChange = index => {
    setCounter(index + 1);
    onImageChange(images[index]);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(atoms/* Box */.xu, (0,esm_extends/* default */.Z)({
    "data-testid": "media-gallery",
    fontSize: 0,
    position: "relative"
  }, props), /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
    lazy: lazy,
    onChange: handleImageChange,
    showControls: false,
    auto: false
  }, images.map((image, index) => /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    height: imgMaxHeight,
    key: `gallery-img-${index}`
  }, /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    key: `gallery-img-${index}`,
    src: image,
    m: "auto",
    width: imgWidth,
    height: imgHeight,
    maxHeight: imgMaxHeight,
    lazy: !preload || index !== 0,
    onClick: () => onImageClick(index)
  })))), showMedia && /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    "data-testid": "media-gallery-icons",
    position: "absolute",
    bottom: "16px",
    left: "16px",
    columnGap: 2
  }, !!video && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "VideoCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('video'),
    "data-testid": "media-gallery-video-icon"
  }), !!audio && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "PodcastCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('audio'),
    "data-testid": "media-gallery-audio-icon"
  })), showCounter && !!images.length && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    "data-testid": "media-gallery-counter",
    bg: "background.dark",
    color: "text.lightest",
    position: "absolute",
    bottom: "16px",
    right: "16px",
    paddingX: 2,
    paddingY: 1,
    borderRadius: "default",
    opacity: "85%"
  }, imagesCounter, counterSeparator, images.length)), dialogVisible && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    title: null,
    position: "center",
    showClose: true,
    onClickOutside: toggleDialog,
    visible: true
  }, mediaTypeRender[dialogVisible]));
};

 false ? 0 : void 0;
MediaCarousel.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  lazy: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaCarousel = (MediaCarousel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaGallery.js







const MediaGallery = _ref => {
  let {
    alt,
    title,
    audios,
    images,
    podcasts,
    videos,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showThumbnail,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audios", "images", "podcasts", "videos", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showThumbnail", "showMoreTooltip", "smallThumbnails", "lazy", "preload"]);

  const GalleryType = showThumbnail ? MediaGallery_MediaThumbnails : MediaGallery_MediaCarousel;
  const [video] = videos;
  const [audio] = [...podcasts, ...audios];
  const showMedia = !!video || !!audio;
  return /*#__PURE__*/react.createElement(GalleryType, (0,esm_extends/* default */.Z)({
    alt: alt,
    title: title,
    audio: audio,
    video: video,
    images: images,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    imgMaxHeight: imgMaxHeight,
    onImageClick: onImageClick,
    onAudioClick: onAudioClick,
    onVideoClick: onVideoClick,
    onImageChange: onImageChange,
    showMedia: showMedia,
    showMoreTooltip: showMoreTooltip,
    smallThumbnails: smallThumbnails,
    preload: preload
  }, props));
};

 false ? 0 : void 0;
MediaGallery.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  onImageChange: () => {},
  onImageClick: () => {},
  onVideoClick: () => {},
  onAudioClick: () => {},
  showThumbnail: false,
  showMoreTooltip: '',
  smallThumbnails: false,
  lazy: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaGallery = (MediaGallery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/index.js


/***/ }),

/***/ 56337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ opinion_snippet_block; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var esm = __webpack_require__(87879);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 6 modules
var organisms = __webpack_require__(28167);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/helpers.js
const formatMediaList = (array = [], type) => {
  return array.map(elem => {
    return {
      mediaUrl: elem,
      mediaType: type,
      original: elem.includes('original'),
      processed: elem.includes('processed'),
      thumbnails: elem.includes('thumbnails')
    };
  });
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/opinion-snippet-block.styles.js



const Header = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)`
  align-items: center;
  padding: 0 0 ${props => (0,build_esm.themeGet)('space.2')(props)}px;

  ${(0,build_esm.getMediaQuery)('large')} {
    padding: 0 0 ${props => (0,build_esm.themeGet)('space.3')(props)}px;
  }
`;
const ReviewWrapper = styled_components_browser_esm["default"].span`
  width: 80px;
`;
const ReviewerName = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm.themeGet)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm.themeGet)('space.2')(props)}px;
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.plus')(props)}px;
`;
const SubTitle = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.plus')(props)}px;
`;
const Description = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(() => ({
  fontSize: 3
}))`
  color: ${props => (0,build_esm.themeGet)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  line-height: 24px;
  padding: ${props => (0,build_esm.themeGet)('space.3')(props)}px 0
    ${props => (0,build_esm.themeGet)('space.3')(props)}px;
  word-break: break-word;
`;
const SeeMore = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const DateWrapper = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.tall')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/opinion-snippet-block.js











const renderGallery = (mediasList, openPopup) => {
  return mediasList.map(elem => /*#__PURE__*/react.createElement(MediaReviewCard/* default */.Z, {
    key: `gallery-media-${elem.mediaUrl}`,
    media: elem,
    onClick: () => openPopup(elem.mediaUrl.split('/').reverse()[0]),
    width: "124px",
    height: "124px"
  }));
};

const OpinionSnippetBlock = ({
  review,
  charLimit
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData,
    product
  } = review;
  const isShortDescription = (description == null ? void 0 : description.length) <= charLimit;
  const [isPopupOpen, setIsPopupOpen] = (0,react.useState)(false);
  const [selectedMedia, setSelectedMedia] = (0,react.useState)(0);
  /**
   * check if it has only digits - in case to be a timestamp
   */

  const isTimestamp = /^\d+$/.test(submissionDate);
  const days = submissionDate && !isTimestamp && (0,esm/* formatDateDistance */.jL)(new Date(submissionDate), new Date());
  const subtitle = (attributes == null ? void 0 : attributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
  const arrayImages = formatMediaList(product == null ? void 0 : product.images, 'image');
  const arrayVideos = formatMediaList(product == null ? void 0 : product.videos, 'video');
  const processedMedias = arrayImages.filter(elem => elem.processed).concat(arrayVideos.filter(elem => elem.processed));
  const thumbnailsMedias = arrayImages.filter(elem => elem.thumbnails).concat(arrayVideos.filter(elem => elem.thumbnails));

  const openPopup = name => {
    const mediaId = processedMedias.findIndex(elem => elem.mediaUrl.includes(name.split('.')[0]));
    setSelectedMedia(mediaId > 0 ? mediaId : 0);
    setIsPopupOpen(true);
  };

  return /*#__PURE__*/react.createElement(Box/* default */.Z, null, /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(ReviewerName, null, userData == null ? void 0 : userData.name), /*#__PURE__*/react.createElement(ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/react.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), description && /*#__PURE__*/react.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : `${description.substring(0, charLimit)}...`, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    "data-testid": "see-more-btn",
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/react.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`), thumbnailsMedias.length > 0 && /*#__PURE__*/react.createElement(organisms/* ProductReviewGallery */.zT, null, renderGallery(thumbnailsMedias, openPopup)), isPopupOpen && /*#__PURE__*/react.createElement(organisms/* ProductReviewPopup */.Qp, {
    review: review,
    charLimit: charLimit,
    mediaProps: arrayImages.concat(arrayVideos),
    selectedMedia: selectedMedia,
    closePopup: () => setIsPopupOpen(false)
  }));
};

 false ? 0 : void 0;
OpinionSnippetBlock.defaultProps = {
  charLimit: 110,
  mediaReview: null
};
/* harmony default export */ var opinion_snippet_block = (OpinionSnippetBlock);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/index.js


/***/ }),

/***/ 1939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shipping_tags; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var esm = __webpack_require__(87879);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.styles.js



const ProductShippingCost = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs(() => ({
  fontSize: 0,
  fontWeight: 'regular',
  marginTop: 1
}))`
  color: ${(0,build_esm.getTextColor)('scratched')};
`;
const Container = styled_components_browser_esm["default"].div``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.styles.js
var product_card_styles = __webpack_require__(57862);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js









const ProductCardShippingTag = ({
  showShippingTags,
  shippingTag,
  price
}) => {
  const {
    time,
    cost,
    complement
  } = shippingTag;
  const showTagInternational = (0,utils/* isInternationalPrice */.xx)(price);
  const costDescription = cost === 0 ? 'Frete grátis' : `Frete: ${(0,esm/* currencyFormatter */.oB)({
    value: cost
  })}`;

  const ShippingCost = () => {
    return cost === 0 ? /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, costDescription) : /*#__PURE__*/react.createElement(ProductShippingCost, null, costDescription);
  };

  return /*#__PURE__*/react.createElement(Box/* default */.Z, {
    marginTop: 1
  }, showTagInternational && /*#__PURE__*/react.createElement(TagInternational/* default */.Z, null), showShippingTags && /*#__PURE__*/react.createElement(Container, {
    "data-testid": "productCard-shipping-tag"
  }, cost !== null && cost !== undefined && /*#__PURE__*/react.createElement(ShippingCost, null), time && /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, time), complement && /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, complement)));
};

 false ? 0 : void 0;
ProductCardShippingTag.defaultProps = {
  showShippingTags: false,
  shippingTag: {},
  price: {}
};
/* harmony default export */ var shipping_tags = (ProductCardShippingTag);

/***/ }),

/***/ 47719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.styles.js
var product_card_styles = __webpack_require__(57862);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 6 modules
var organisms = __webpack_require__(28167);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/card-header.styles.js





const HeaderEl = (0,styled_components_browser_esm["default"])(atoms/* Grid */.rj)`
  grid-template-columns: 1fr ${({
  displayMode,
  sponsored,
  isMagaluIndica
}) => displayMode !== constants/* LIST */.IY && isMagaluIndica || displayMode === constants/* MINIATURE */.Co && sponsored ? '20px' : ''};
  margin-bottom: ${(0,build_esm.themeGet)('space.1')}px;
  ${props => props.displayMode === constants/* LIST */.IY && `
    grid-column-start: 3;
    grid-row-start: 1;
    align-self: start;
  `}
`;
const MagaluIndica = (0,styled_components_browser_esm["default"])(atoms/* Chip */.Af).attrs(props => Object.assign({}, props))`
  justify-self: start;
`;
const WishlistBtn = (0,styled_components_browser_esm["default"])(molecules/* AddWishlistButton */.iG).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/card-header.js







const CardHeader = ({
  displayMode,
  sponsored,
  showWishBtn,
  isLiked,
  handleAddToWishlist,
  isMagaluIndica,
  isMercadoFull
}) => /*#__PURE__*/react.createElement(HeaderEl, {
  isMagaluIndica: isMagaluIndica || isMercadoFull,
  displayMode: displayMode,
  sponsored: sponsored
}, sponsored && displayMode === constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* SponsoredEl */.lK, {
  place: "header"
}, "Patrocinado"), (isMagaluIndica || isMercadoFull) && displayMode === constants/* GALLERY */.yg && /*#__PURE__*/react.createElement(MagaluIndica, {
  autoSize: true,
  padding: "2px 8px",
  bg: "primary",
  fontSize: 1,
  startIcon: isMagaluIndica ? /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "FastDelivery",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }) : /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "FastMarket",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }),
  fontWeight: "bold",
  gridGap: 1,
  minWidth: "unset",
  borderRadius: 6
}, isMagaluIndica ? 'Full' : 'Mercado Full'), showWishBtn && /*#__PURE__*/react.createElement(WishlistBtn, {
  active: isLiked,
  onClick: handleAddToWishlist
}));

 false ? 0 : void 0;
/* harmony default export */ var card_header = (CardHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/GeoLocTags/geoloc-tags.js







const ProductCardGeoLocTags = ({
  geoLocTags,
  displayMode
}) => {
  return geoLocTags != null && geoLocTags.title ? /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: displayMode === constants/* MINIATURE */.Co ? 'center' : null,
    gap: 1
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: geoLocTags.icon || 'FastDelivery',
    color: "text.primary",
    width: 30,
    height: 30
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    color: "text.primary",
    fontSize: [1, 1, 2, 2],
    fontWeight: "medium"
  }, geoLocTags.title))) : null;
};

 false ? 0 : void 0;
/* harmony default export */ var geoloc_tags = (ProductCardGeoLocTags);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/GeoLocTags/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/review-variations.styles.js

const reviewGroupVariation = {
  miniature: styled_components_browser_esm.css`
    justify-self: center;
    align-self: center;
  `,
  list: styled_components_browser_esm.css`
    justify-self: left;
  `
};
const ReviewGroup = styled_components_browser_esm["default"].div`
  ${({
  displayMode
}) => displayMode && reviewGroupVariation[displayMode]};
  max-height: 20px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/review-variations.js




const renderReviewVariations = ({
  displayMode,
  count,
  score,
  allowEmptyRating,
  showRating,
  format,
  isSellerPage
}) => {
  const shouldHideRating = !allowEmptyRating && !score;

  if (shouldHideRating || !showRating) {
    return null;
  }

  return /*#__PURE__*/react.createElement(ReviewGroup, {
    displayMode: displayMode
  }, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    format: format,
    score: score,
    count: count,
    width: isSellerPage ? '20px' : '12px',
    height: isSellerPage ? '20px' : '12px',
    isSellerPage: isSellerPage
  }));
};

/* harmony default export */ var review_variations = (renderReviewVariations);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AllGeoLocTags/all-geoloc-tags.js





const ProductCardAllGeoLocTags = ({
  allGeoLocTags,
  displayMode
}) => {
  return allGeoLocTags.length > 0 && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    display: "none",
    "data-testid": "allGeoLocTags",
    flexDirection: "column"
  }, allGeoLocTags.map((geoLocTag, index) => {
    return geoLocTag.title && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      key: index,
      alignItems: "center",
      display: displayMode === constants/* MINIATURE */.Co ? 'none' : null,
      color: "text.primary",
      fontSize: "0",
      fontWeight: "medium"
    }, geoLocTag.title);
  }));
};

 false ? 0 : void 0;
ProductCardAllGeoLocTags.defaultProps = {
  allGeoLocTags: []
};
/* harmony default export */ var all_geoloc_tags = (ProductCardAllGeoLocTags);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AllGeoLocTags/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js + 1 modules
var shipping_tags = __webpack_require__(1939);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js + 2 modules
var LoyaltyCommission = __webpack_require__(99075);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/Loyalty/loyalty.js






const loyaltyComponent = {
  sales_commission: LoyaltyCommission/* default */.Z,
  sales_dynamic_commission: LoyaltyCommission/* default */.Z
};

const Loyalty = ({
  displayMode,
  loyalty,
  productUrl
}) => {
  const LoyaltyComponent = loyaltyComponent[loyalty == null ? void 0 : loyalty.type];
  if (!loyalty) return null;
  return /*#__PURE__*/react.createElement(product_card_styles/* LoyaltyContainer */.RJ, {
    displayMode: displayMode
  }, LoyaltyComponent && /*#__PURE__*/react.createElement(LoyaltyComponent, (0,esm_extends/* default */.Z)({}, loyalty, {
    productUrl: productUrl
  })));
};

Loyalty.defaultProps = {
  displayMode: constants/* LIST */.IY,
  loyalty: {},
  productUrl: ''
};
 false ? 0 : void 0;
/* harmony default export */ var Loyalty_loyalty = (Loyalty);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/Loyalty/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js + 2 modules
var ProductCardPrice = __webpack_require__(12795);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CartQuantity/card-quantity.js





const CardQuantity = ({
  quantity,
  min,
  max,
  onIncrement,
  onDecrement,
  dataTestId
}) => {
  return /*#__PURE__*/react.createElement(product_card_styles/* StepperContainer */.Xz, null, /*#__PURE__*/react.createElement(molecules/* QuantityStepper */.cr, {
    value: quantity,
    min: min,
    max: max,
    onDecrement: e => onDecrement(e),
    onIncrement: e => onIncrement(e),
    dataTestId: dataTestId
  }));
};

/* harmony default export */ var card_quantity = (CardQuantity);
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CartQuantity/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AddToCartArea/add-to-cart-area.styles.js


const AddToCartButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)`
  border: 1px solid #2fa0fd;
  color: #0075e2;
  align-self: end;
  font-weight: 500;
  border-radius: 8px;
  font-size: 14px;

  &:hover {
    color: #0075e2;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AddToCartArea/add-to-cart-area.js





const qtyReducer = (state, action, min = 1) => {
  switch (action.type) {
    case 'INCREMENT':
      return state >= min ? state + 1 : min;

    case 'DECREMENT':
      return state <= min ? 0 : Math.max(0, state - 1);

    default:
      return state;
  }
};

const AddToCartArea = ({
  product,
  quantity,
  onQuantityChange
}) => {
  const handleQuantityChange = (e, actionType) => {
    e.preventDefault();
    e.stopPropagation();
    onQuantityChange(actionType);
  };

  if (quantity) {
    var _product$restrictions;

    return /*#__PURE__*/react.createElement(card_quantity, {
      "aria-label": "Seletor de quantidade",
      quantity: quantity,
      max: (product == null ? void 0 : (_product$restrictions = product.restrictions) == null ? void 0 : _product$restrictions.max_checkout_quantity) || constants/* DEFAULT_PRODUCT_MAX_CHECKOUT_QUANTITY */.kk,
      onIncrement: e => handleQuantityChange(e, 'INCREMENT'),
      onDecrement: e => handleQuantityChange(e, 'DECREMENT'),
      dataTestId: "add-to-cart-qty"
    });
  }

  if (!(product != null && product.hasVariations)) {
    return /*#__PURE__*/react.createElement(AddToCartButton, {
      "aria-label": "Adicionar \xE0 sacola",
      customColor: {
        default: '#EDF8FF',
        hover: '#EDF8FF'
      },
      full: true,
      variation: "fill",
      centered: true,
      onMouseDown: e => e.stopPropagation(),
      onClick: e => handleQuantityChange(e, 'INCREMENT'),
      mt: "8px",
      size: "small",
      uppercase: false,
      "data-testid": "add-to-cart-button"
    }, "Adicionar \xE0 sacola");
  }

  return null;
};

 false ? 0 : void 0;
AddToCartArea.defaultProps = {
  onQuantityChange: () => {}
};
/* harmony default export */ var add_to_cart_area = (AddToCartArea);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AddToCartArea/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/parseEcommerceProductId.js
var parseEcommerceProductId = __webpack_require__(15970);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.js





















const parseUrl = ({
  domain,
  url,
  adsSellerId
}) => {
  const isFullURL = /^https?:\/\//.test(url);
  const productUrl = new URL(isFullURL ? url : domain + url);

  if (adsSellerId) {
    productUrl.searchParams.append('seller_id', adsSellerId);
  }

  const absoluteUrl = productUrl.toString();
  const href = isFullURL ? absoluteUrl : absoluteUrl.replace(productUrl.origin, '');
  return {
    absoluteUrl,
    href
  };
};

const iconProps = {
  fill: '#fff',
  width: '16px',
  height: '16px'
};

const renderDeliveryTags = (isMagaluIndica, isMercadoFull, defaultTagProps) => {
  const tags = [];

  if (isMagaluIndica) {
    tags.push( /*#__PURE__*/react.createElement(product_card_styles/* MagaluIndica */.Tl, (0,esm_extends/* default */.Z)({
      key: "magalu"
    }, defaultTagProps, {
      startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, (0,esm_extends/* default */.Z)({
        name: "FastDelivery"
      }, iconProps))
    }), "Full"));
  }

  if (isMercadoFull) {
    tags.push( /*#__PURE__*/react.createElement(product_card_styles/* MercadoFull */.Lq, (0,esm_extends/* default */.Z)({
      key: "mercado"
    }, defaultTagProps, {
      startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, (0,esm_extends/* default */.Z)({
        name: "FastMarket"
      }, iconProps))
    }), "Mercado Full"));
  }

  return tags.length > 0 ? tags : null;
};

const shouldShowReward = reward => Boolean(reward == null ? void 0 : reward.active);

const renderRewardAlert = reward => {
  if (!shouldShowReward(reward)) {
    return null;
  }

  return /*#__PURE__*/react.createElement(molecules/* AlertText */.QP, {
    icon: reward == null ? void 0 : reward.icon,
    message: reward == null ? void 0 : reward.message,
    intent: reward == null ? void 0 : reward.intent,
    styleContainer: reward == null ? void 0 : reward.styleContainer,
    styleMessage: reward == null ? void 0 : reward.styleMessage
  });
};

const getImageAltText = ({
  imageAltPrefix,
  title
}) => imageAltPrefix ? `${imageAltPrefix}${title}` : title;

const ProductCard = _ref => {
  let {
    hideLinkBorder,
    onClick,
    onMouseDown,
    onView,
    domain,
    imgLazyLoading,
    index,
    lazyLoadingOffset,
    showInCashInfo,
    enableShadow,
    enableHover,
    geoLocTags,
    allGeoLocTags,
    hidePriceMode,
    hidePrice,
    hidePriceButtonAction,
    showPreview,
    previewAction,
    showWishBtn,
    onClickWishBtn,
    fullHeight,
    showRating,
    showDiscount,
    showDiscountOnlyCashInfo,
    allowEmptyRating,
    containerWidth,
    onThumbnailClick,
    onVariationClick,
    colorMinLength,
    attributeStyle,
    offerTimerProps,
    addToCart,
    showAddToCartButton,
    hidePriceWhen,
    hideShippingTagWhen
  } = _ref,
      product = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["adId", "hideLinkBorder", "onClick", "onMouseDown", "onView", "domain", "imgLazyLoading", "index", "lazyLoadingOffset", "showInCashInfo", "enableShadow", "enableHover", "geoLocTags", "allGeoLocTags", "hidePriceMode", "hidePrice", "hidePriceButtonAction", "showPreview", "previewAction", "showWishBtn", "onClickWishBtn", "fullHeight", "showRating", "percentBadge", "showDiscount", "showDiscountOnlyCashInfo", "allowEmptyRating", "containerWidth", "onThumbnailClick", "onVariationClick", "colorMinLength", "attributeStyle", "offerTimerProps", "addToCart", "showAddToCartButton", "hidePriceWhen", "hideShippingTagWhen"]);

  const {
    displayMode,
    title,
    price,
    image,
    installment,
    badges,
    rating,
    variationId,
    url,
    titleAs,
    loyalty,
    isOnWishlist,
    imageWidth,
    imageHeight,
    shippingCost,
    shippingTag,
    brand,
    offerTags,
    ads,
    adsSellerId,
    thumbnails,
    restrictions,
    parsedAttributes,
    reward,
    tagCoupon,
    isSellerPage,
    isSlider,
    minimumOrderQuantity
  } = product;
  const {
    absoluteUrl,
    href
  } = parseUrl({
    domain,
    url,
    adsSellerId
  });
  const {
    count,
    score
  } = rating;
  const isMagaluIndica = offerTags == null ? void 0 : offerTags.includes('magalu_indica');
  const isMercadoFull = offerTags == null ? void 0 : offerTags.includes('mercado_full');
  const [quantity, setQuantity] = (0,react.useState)((product == null ? void 0 : product.inBagQuantity) || 0);
  const badge = badges == null ? void 0 : badges.slice(-1)[0];
  const currentQuantity = (0,react.useMemo)(() => (product == null ? void 0 : product.inBagQuantity) || 0, [product == null ? void 0 : product.inBagQuantity]);
  (0,react.useEffect)(() => {
    setQuantity(currentQuantity);
  }, [currentQuantity]);
  const handleQuantityChange = (0,react.useCallback)(actionType => {
    const previousQuantity = quantity;
    const nextQuantity = qtyReducer(quantity, {
      type: actionType
    }, minimumOrderQuantity);
    setQuantity(nextQuantity);

    const rollback = () => setQuantity(previousQuantity);

    const productId = (0,parseEcommerceProductId/* default */.Z)(product);
    addToCart(product, productId, String(nextQuantity), rollback);
  }, [quantity, product]);

  const handleAddToWishlist = e => {
    e.stopPropagation();
    e.preventDefault();
    onClickWishBtn(e);
  };

  const handleVariationClick = (e, variation) => {
    if (onVariationClick) {
      onVariationClick(e, variation, product);
      return;
    }

    if (onThumbnailClick) {
      onThumbnailClick(e, variation, product);
    }
  };

  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0.5,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView(Object.assign({
        index,
        geoLocTags
      }, product));
    }
  }, [inView]);
  const adIdValidated = (ads == null ? void 0 : ads.id) || undefined;
  const priceData = {
    hide: hidePriceMode === 'hide' || (hidePriceWhen == null ? void 0 : hidePriceWhen(product)),
    hiddenPrice: hidePrice,
    displayMode,
    installment,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    price,
    hidePriceButtonAction,
    product
  };
  const defaultTagProps = {
    autoSize: true,
    bg: 'primary',
    borderRadius: 6,
    fontSize: 1,
    fontWeight: 'medium',
    gridGap: 1,
    mb: 1,
    minWidth: 'unset',
    padding: '2px 8px'
  };
  const rewardAlert = renderRewardAlert(reward);
  return /*#__PURE__*/react.createElement(product_card_styles/* Container */.W2, {
    ref: ref,
    href: href,
    onClick: e => onClick(e, Object.assign({}, product, {
      index
    })),
    onMouseDown: e => onMouseDown(e, Object.assign({}, product, {
      index
    })),
    displayMode: displayMode,
    "data-testid": "product-card-container",
    "ads-click-event": adIdValidated,
    "ads-view-event": adIdValidated,
    "ads-impression-event": adIdValidated,
    redirect: href,
    hideLinkBorder: hideLinkBorder,
    enableShadow: enableShadow,
    enableHover: enableHover,
    fullHeight: fullHeight,
    containerWidth: containerWidth,
    index: index,
    "data-brand": brand == null ? void 0 : brand.slug,
    isSellerPage: isSellerPage,
    isSlider: isSlider
  }, /*#__PURE__*/react.createElement(card_header, {
    displayMode: displayMode,
    sponsored: ads == null ? void 0 : ads.sponsored,
    showWishBtn: showWishBtn,
    isLiked: isOnWishlist,
    handleAddToWishlist: handleAddToWishlist,
    isMagaluIndica: isMagaluIndica,
    isMercadoFull: isMercadoFull
  }), /*#__PURE__*/react.createElement(product_card_styles/* ImageContainer */.mo, {
    displayMode: displayMode,
    isSellerPage: isSellerPage
  }, displayMode === constants/* LIST */.IY && renderDeliveryTags(isMagaluIndica, isMercadoFull, defaultTagProps), /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: image,
    alt: getImageAltText(product),
    width: imageWidth,
    height: imageHeight,
    title: title,
    lazy: imgLazyLoading,
    offset: lazyLoadingOffset,
    mb: 1
  }), /*#__PURE__*/react.createElement(Loyalty_loyalty, {
    displayMode: displayMode,
    loyalty: loyalty,
    productUrl: absoluteUrl
  }), !!badge && /*#__PURE__*/react.createElement(molecules/* Badge */.Ct, {
    key: `${variationId}-badge-${badge.id}`,
    url: badge.imageUrl,
    tooltip: badge.tooltip,
    displayMode: displayMode,
    borderRadius: "medium"
  }), displayMode === constants/* LIST */.IY && parsedAttributes && /*#__PURE__*/react.createElement(organisms/* AttributeList */.dO, {
    attributes: parsedAttributes,
    variations: thumbnails,
    colorVariant: "button",
    showTitle: false,
    colorMinLength: colorMinLength,
    gap: 1,
    style: attributeStyle,
    onVariationClick: handleVariationClick
  })), showPreview && /*#__PURE__*/react.createElement(product_card_styles/* ButtonPreviewContainer */.Mn, {
    "data-testid": "button-preview-container"
  }, /*#__PURE__*/react.createElement(product_card_styles/* ButtonPreview */.AH, {
    size: "small",
    m: '10px 0',
    "data-testid": "button-preview",
    onClick: e => {
      e.preventDefault();
      previewAction(product);
    }
  }, "Conferir")), /*#__PURE__*/react.createElement(product_card_styles/* Content */.VY, {
    displayMode: displayMode,
    "data-testid": "product-card-content"
  }, displayMode !== constants/* LIST */.IY && parsedAttributes && /*#__PURE__*/react.createElement(organisms/* AttributeList */.dO, {
    attributes: parsedAttributes,
    variations: thumbnails,
    onVariationClick: handleVariationClick,
    colorVariant: "button",
    showTitle: false,
    gap: 1,
    colorMinLength: colorMinLength,
    style: attributeStyle
  }), displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(molecules/* OfferTimer */.dV, (0,esm_extends/* default */.Z)({
    height: 20,
    fontSize: ['10px', 1],
    restrictions: restrictions,
    displayMode: displayMode
  }, offerTimerProps)), (ads == null ? void 0 : ads.sponsored) && displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* SponsoredEl */.lK, {
    place: "content"
  }, "Patrocinado"), displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* Title */.Dx, {
    as: titleAs,
    displayMode: displayMode,
    "data-testid": "product-title"
  }, title), review_variations({
    displayMode,
    count,
    score,
    allowEmptyRating,
    showRating,
    format: 'score-count',
    isSellerPage
  }), /*#__PURE__*/react.createElement(geoloc_tags, {
    geoLocTags: geoLocTags,
    displayMode: displayMode
  }), /*#__PURE__*/react.createElement(ProductCardPrice/* default */.Z, (0,esm_extends/* default */.Z)({}, priceData, {
    isSellerPage: isSellerPage
  })), /*#__PURE__*/react.createElement(molecules/* TagCoupon */.rE, {
    mt: 1,
    tags: tagCoupon
  }), /*#__PURE__*/react.createElement(molecules/* ProductShipping */.lF, {
    displayMode: displayMode,
    costDescription: shippingCost.costDescription,
    cost: shippingCost.cost
  }), /*#__PURE__*/react.createElement(all_geoloc_tags, {
    allGeoLocTags: allGeoLocTags,
    displayMode: displayMode
  }), /*#__PURE__*/react.createElement(shipping_tags/* default */.Z, {
    showShippingTags: displayMode !== constants/* MINIATURE */.Co && !(hideShippingTagWhen != null && hideShippingTagWhen(product)),
    shippingTag: shippingTag,
    price: price
  }), rewardAlert, showAddToCartButton(product) && /*#__PURE__*/react.createElement(add_to_cart_area, {
    product: product,
    quantity: quantity,
    onQuantityChange: handleQuantityChange
  })));
};

/* harmony default export */ var product_card = (ProductCard);
 false ? 0 : void 0;
ProductCard.defaultProps = {
  variationId: '',
  url: '',
  displayMode: constants/* LIST */.IY,
  domain: constants/* MAGALU_DOMAIN */.RW,
  title: '',
  image: '',
  index: 0,
  price: {},
  installment: {},
  geoLocTags: {},
  allGeoLocTags: [],
  rating: {},
  badges: [],
  brand: {},
  onClick: () => {},
  onMouseDown: () => {},
  onView: () => {},
  imgLazyLoading: false,
  fullHeight: false,
  percentBadge: 30,
  lazyLoadingOffset: 50,
  showInCashInfo: true,
  hideLinkBorder: false,
  titleAs: 'h2',
  enableShadow: true,
  enableHover: false,
  imageAltPrefix: '',
  hidePriceMode: 'blur',
  hidePrice: false,
  hidePriceButtonAction: null,
  showPreview: false,
  previewAction: () => {},
  isOnWishlist: false,
  showWishBtn: false,
  onClickWishBtn: () => {},
  showRating: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: true,
  shippingCost: {},
  ads: {},
  shippingTag: {},
  allowEmptyRating: false,
  onThumbnailClick: null,
  onVariationClick: null,
  colorMinLength: 3,
  attributeStyle: {
    width: '42px',
    height: '42px',
    bg: 'background.lighter',
    color: 'background.primary',
    shouldHover: true
  },
  offerTimerProps: {},
  isSellerPage: false,
  isSlider: false,
  addToCart: () => {},
  showAddToCartButton: () => false,
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js


/***/ }),

/***/ 57862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ ButtonPreview; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Lq": function() { return /* binding */ MercadoFull; },
/* harmony export */   "Mn": function() { return /* binding */ ButtonPreviewContainer; },
/* harmony export */   "RJ": function() { return /* binding */ LoyaltyContainer; },
/* harmony export */   "Tl": function() { return /* binding */ MagaluIndica; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "Xz": function() { return /* binding */ StepperContainer; },
/* harmony export */   "dO": function() { return /* binding */ ShippingDescription; },
/* harmony export */   "lK": function() { return /* binding */ SponsoredEl; },
/* harmony export */   "mo": function() { return /* binding */ ImageContainer; }
/* harmony export */ });
/* unused harmony export WishlistBtn */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99673);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68054);
/* harmony import */ var _magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55403);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26865);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12468);
/* harmony import */ var _atoms_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27439);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87043);








const getContainer = (displayMode, containerWidth) => {
  const sizes = {
    miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
      display: grid;
      padding: 8px 2px;
    `,
    list: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
      display: grid;
      grid-template-columns: 1.5fr 2fr;
      ${containerWidth >= 500 && styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
        ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getMediaQuery)('small')} {
          grid-template-columns: 180px 2fr;
          grid-column-gap: 20px;
        }
      `}
      padding: 16px;
    `,
    gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
      grid-template-rows: auto auto 1fr;
    `,
    sponsoredBrand: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
      height: 107px;
      width: 100px;
      padding: 4px;
      border: 1px solid #d3dadd;
    `,
    sponsoredBrandMedium: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
      height: 254px;
      width: 199px;
      border: 1px solid #d3dadd;

      &:hover {
        border: 1px solid #d3dadd;
      }
    `
  };
  return sizes[displayMode];
};

const SponsoredEl = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(props => Object.assign({
  fontSize: 13,
  fontWeight: 'regular',
  lineHeight: 'display'
}, props))`
  justify-self: left;
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getTextColor)('light')};

  ${styled_system__WEBPACK_IMPORTED_MODULE_0__.typography}
`;
const WishlistBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_molecules__WEBPACK_IMPORTED_MODULE_2__/* .AddWishlistButton */ .iG).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;
const Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)`
  position: relative;
  padding: 10px;
  justify-content: unset;
  background-color: ${props => props.hideLinkBorder ? 'unset' : (0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getPaletteColor)('background.lighter')(props)};
  ${({
  displayMode,
  containerWidth
}) => displayMode && getContainer(displayMode, containerWidth)};
  display: grid;

  ${({
  fullHeight
}) => fullHeight && `
    display: flex;
    flex-direction: column;
    height: 100%;
  `}
  ${({
  isSellerPage,
  isSlider
}) => {
  if (isSellerPage && !isSlider) {
    return `
        width: 263.59px !important;
        min-width: 263.59px !important;
        max-width: 263.59px !important;
        border: 1px solid #D3DADD;
      `;
  }

  if (isSellerPage && isSlider) {
    return `
        width: 218px;
        min-width: 218px;
        max-width: 218px;
        border: 1px solid #D3DADD;
      `;
  }

  if (isSellerPage) {
    return 'border: 1px solid #D3DADD;';
  }

  return '';
}}
`;
const imgContainerDisplay = {
  miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    height: 20vw;
    justify-content: flex-end;
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getMediaQuery)('small')} {
      height: 120px;
    }
  `,
  list: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
    & > img {
      max-height: 160px;
    }
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getMediaQuery)('small')} {
      min-height: initial;
      max-height: 210px;
    }
  `,
  gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    height: 32vw;
    justify-content: flex-end;
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getMediaQuery)('small')} {
      max-height: 210px;
    }
  `,
  sponsoredBrand: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    height: 56px;
    width: 84px;
  `,
  sponsoredBrandMedium: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    height: 127px;
    width: 173px;
  `
}; // "& > .lazyload-wrapper" stylizes the image's <LazyLoad> container

const ImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  position: relative;
  display: flex;
  flex-direction: column;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
  ${({
  isSellerPage
}) => isSellerPage && `
    width: 100%;
    height: 144px;
  `}
`;
const LoyaltyContainerDisplay = {
  miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    justify-content: center;
  `,
  list: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    justify-content: flex-start;
  `,
  gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__.css`
    justify-content: flex-end;
  `
};
const LoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  position: absolute;
  display: flex;
  width: 100%;
  top: 5%;
  ${({
  displayMode
}) => displayMode && LoyaltyContainerDisplay[displayMode]}
`;
const Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(props => Object.assign({
  fontSize: props.displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND */ .tc ? [1, 1, 1] : '10px',
  lineHeight: 'display',
  fontWeight: 'regular'
}, props))`
  ${({
  displayMode
}) => {
  if (displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY) return `height: 32px;`;
  if (displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND */ .tc) return `height: 36px;`;
  if (displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND_MEDIUM */ .Pl) return `height: 36px;`;
  return `height: 52px;`;
}}
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getTextColor)('base')};
  -webkit-line-clamp: ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY ? 3 : 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND */ .tc ? `margin: 4px 0 4px 0;` : ` margin: 0`};

  ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getMediaQuery)('small')} {
    ${({
  displayMode
}) => displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && `height: 40px;`};
  }
  ${styled_system__WEBPACK_IMPORTED_MODULE_0__.typography}
`;
const Content = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  ${({
  displayMode
}) => displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && `padding-left: 8px`}
  ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND */ .tc && displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .SPONSORED_BRAND_MEDIUM */ .Pl && `
    display: grid;
    padding-top: 8px;
  `}
`;
const StepperContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  align-self: end;
  display: flex;
  margin-top: 8px;
`;
const ButtonPreviewContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  width: 100%;
  height: 15px;
  position: relative;
`;
const ButtonPreview = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx)`
  opacity: 0.7;
  visibility: hidden;
  position: absolute;
  width: 50%;
  min-width: 90px;

  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;

  &:hover {
    opacity: 1;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${Container}:hover & {
    visibility: visible;
  }
`;
const MagaluIndica = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Chip */ .Af).attrs(props => Object.assign({}, props))`
  width: 66px;
`;
const MercadoFull = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Chip */ .Af).attrs(props => Object.assign({}, props))`
  width: 126px;
`;
const ShippingDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(() => ({
  fontSize: 0,
  fontWeight: 'medium',
  marginTop: 1
}))`
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__.getTextColor)('primary')};
`;

/***/ }),

/***/ 3018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card_horizontal; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/index.js + 2 modules
var OfferTimer = __webpack_require__(3310);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/index.js + 2 modules
var TagCoupon = __webpack_require__(62458);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/product-card-horizontal.styles.js
// codegen: this was automatically generated




const Container = styled_components_browser_esm["default"].a`
  display: flex;
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  height: 100%;
  background-color: #fff;
  max-width: 560px;
  text-decoration: none;
  ${({
  showBorder
}) => showBorder && styled_components_browser_esm.css`
      &,
      &:active,
      &:focus,
      &:hover {
        border: solid 1px ${(0,esm.getBackgroundColor)('primary')};
      }
    `}
`;
const ImageContainer = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)`
  flex-direction: column;
  flex-basis: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;
const Content = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)`
  padding-left: 12px;
  flex-basis: 70%;
  flex-direction: column;
  justify-content: center;
`;
const Title = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: [1, 1, 1],
  lineHeight: 'big',
  fontWeight: 'regular'
}, props))`
  max-height: 44px;
  color: ${(0,esm.getTextColor)('base')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  ${(0,esm.getMediaQuery)('small')} {
    max-height: 44px;
  }
  ${index_esm.typography}
`;
const CardButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx).attrs(props => Object.assign({}, props))`
  background-color: #4ea900;
  border-radius: 8px;
  margin-top: 12px;
  max-width: 264px;
  height: 40px;

  ${({
  empty
}) => empty && `
    pointer-events: none;
  `}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js + 1 modules
var shipping_tags = __webpack_require__(1939);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js + 2 modules
var ProductCardPrice = __webpack_require__(12795);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/parseEcommerceProductId.js
var parseEcommerceProductId = __webpack_require__(15970);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/product-card-horizontal.js













function ProductCardHorizontal(_ref) {
  let {
    imgLazyLoading,
    showInCashInfo,
    showDiscount,
    showOfferTimer,
    onView,
    index,
    onClick,
    onMouseDown,
    showDiscountOnlyCashInfo,
    lazyLoadingOffset,
    hidePriceButtonAction,
    showBorder,
    restrictions,
    buttonProps,
    showButton,
    hideOriginalPrice,
    hidePriceWhen,
    hideShippingTagWhen
  } = _ref,
      product = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["imgLazyLoading", "showInCashInfo", "showDiscount", "showOfferTimer", "onView", "index", "geoLocTags", "onClick", "onMouseDown", "showDiscountOnlyCashInfo", "lazyLoadingOffset", "hidePriceButtonAction", "showBorder", "restrictions", "buttonProps", "showButton", "hideOriginalPrice", "hidePriceWhen", "hideShippingTagWhen"]);

  const {
    title,
    price,
    image,
    installment,
    url,
    titleAs,
    shippingTag,
    imageWidth,
    imageHeight,
    imageAltPrefix,
    hidePrice,
    tagCoupon
  } = product;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${product.title}` : product.title;
  const displayMode = 'list';
  const hasRestrictions = Boolean((restrictions == null ? void 0 : restrictions.timer_start_date) && (restrictions == null ? void 0 : restrictions.timer_end_date));
  const hasCoupon = Boolean(tagCoupon && (tagCoupon == null ? void 0 : tagCoupon.discountValue));
  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0.5,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView(Object.assign({
        index
      }, product));
    }
  }, [inView]);
  const priceData = {
    hide: hidePriceWhen == null ? void 0 : hidePriceWhen(product),
    hiddenPrice: hidePrice,
    displayMode,
    installment,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    price,
    hidePriceButtonAction,
    hideOriginalPrice,
    product
  };
  const hasInstallment = !!(installment != null && installment.amount && installment != null && installment.totalAmount && (installment == null ? void 0 : installment.quantity) > 1);
  return /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    href: url,
    index: index,
    onClick: e => {
      const productId = (0,parseEcommerceProductId/* default */.Z)(product);
      onClick(e, Object.assign({}, product, {
        id: productId,
        index
      }));
    },
    onMouseDown: e => {
      const productId = (0,parseEcommerceProductId/* default */.Z)(product);
      onMouseDown(e, Object.assign({}, product, {
        id: productId,
        index
      }));
    },
    "data-testid": "product-card-horizontal",
    showBorder: showBorder
  }, /*#__PURE__*/react.createElement(ImageContainer, {
    width: imageWidth,
    height: imageHeight
  }, /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    src: image,
    alt: imageAlt,
    width: imageWidth,
    height: imageHeight,
    title: title,
    lazy: imgLazyLoading,
    offset: lazyLoadingOffset
  })), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    "data-testid": "product-title"
  }, title), showOfferTimer && hasRestrictions && !hasCoupon && /*#__PURE__*/react.createElement(OfferTimer/* default */.Z, {
    mt: 1,
    mr: 0,
    mb: 0,
    restrictions: {
      timer_start_date: restrictions == null ? void 0 : restrictions.timer_start_date,
      timer_end_date: restrictions == null ? void 0 : restrictions.timer_end_date
    },
    height: "20px",
    fontSize: "14px"
  }), /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: hasInstallment ? 0 : 2
  }, /*#__PURE__*/react.createElement(ProductCardPrice/* default */.Z, priceData)), /*#__PURE__*/react.createElement(TagCoupon/* default */.Z, {
    mt: 1,
    tags: tagCoupon
  }), /*#__PURE__*/react.createElement(shipping_tags/* default */.Z, {
    showShippingTags: !(hideShippingTagWhen != null && hideShippingTagWhen(product)),
    shippingTag: {
      cost: shippingTag == null ? void 0 : shippingTag.cost
    },
    price: price
  }), showButton && /*#__PURE__*/react.createElement(CardButton, (0,esm_extends/* default */.Z)({}, buttonProps, {
    empty: !(buttonProps != null && buttonProps.onClick),
    onClick: buttonProps == null ? void 0 : buttonProps.onClick,
    uppercase: false,
    "data-testid": "better-offer-btn"
  }), (buttonProps == null ? void 0 : buttonProps.title) || 'Ver oferta')));
}

 false ? 0 : void 0;
ProductCardHorizontal.defaultProps = {
  imgLazyLoading: false,
  showInCashInfo: true,
  showDiscount: false,
  url: '',
  onClick: () => {},
  onMouseDown: () => {},
  onView: () => {},
  geoLocTags: {},
  index: 0,
  showDiscountOnlyCashInfo: true,
  lazyLoadingOffset: 50,
  hidePriceButtonAction: () => {},
  showBorder: false,
  restrictions: {
    timer_end_date: prop_types.string,
    timer_start_date: prop_types.string
  },
  showButton: false,
  hideOriginalPrice: false,
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined
};
/* harmony default export */ var product_card_horizontal = (ProductCardHorizontal);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js


/***/ }),

/***/ 12795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card_price; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/product-card-price.styles.js


const HiddenPriceContainer = styled_components_browser_esm["default"].div`
  position: relative;

  span {
    filter: blur(3px);
  }
`;
const ShowPriceButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)`
  visibility: hidden;
  position: absolute;
  bottom: 0;

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${HiddenPriceContainer}:hover & {
    visibility: visible;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/product-card-price.js







const ProductCardPrice = ({
  hide,
  hiddenPrice,
  displayMode,
  installment,
  showInCashInfo,
  showDiscount,
  showDiscountOnlyCashInfo,
  price,
  hidePriceButtonAction,
  hideOriginalPrice,
  product,
  isSellerPage
}) => {
  if (hide) {
    return null;
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, !hiddenPrice && /*#__PURE__*/react.createElement(molecules/* Price */.tA, (0,esm_extends/* default */.Z)({
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: installment,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    hideOriginalPrice: hideOriginalPrice,
    isSellerPage: isSellerPage
  }, price)), hiddenPrice && /*#__PURE__*/react.createElement(HiddenPriceContainer, null, /*#__PURE__*/react.createElement("span", {
    "data-testid": "hided-price"
  }, /*#__PURE__*/react.createElement(molecules/* Price */.tA, {
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: null,
    price: 0.0,
    showInCashInfo: showInCashInfo
  })), hidePriceButtonAction && /*#__PURE__*/react.createElement(ShowPriceButton, {
    full: true,
    size: "small",
    m: '10px 0',
    "data-testid": "show-price-button",
    onClick: e => {
      e.preventDefault();
      hidePriceButtonAction(product);
    }
  }, "Ver Pre\xE7o")));
};

/* harmony default export */ var product_card_price = (ProductCardPrice);
 false ? 0 : void 0;
ProductCardPrice.defaultProps = {
  hide: false,
  hiddenPrice: false,
  displayMode: constants/* LIST */.IY,
  installment: {},
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: true,
  price: {},
  hidePriceButtonAction: null,
  product: {},
  hideOriginalPrice: false,
  isSellerPage: false
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js


/***/ }),

/***/ 4720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 18 modules
var ProductCard = __webpack_require__(47719);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js + 2 modules
var ProductCardHorizontal = __webpack_require__(3018);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/product-carousel.js






function ProductCarousel({
  products,
  displayMode,
  onClick,
  onMouseDown,
  onProductView,
  onChange,
  gutter,
  showInCashInfo,
  slidesPerView,
  interval,
  auto,
  showPartialNextSlide,
  transitionDuration,
  productTitleAs,
  imageAltPrefix,
  imgLazyLoading,
  imageWidth,
  imageHeight,
  showControls,
  showArrowControls,
  showRating,
  enableHover,
  showPreview,
  showDiscount,
  showOfferTimer,
  showDiscountOnlyCashInfo,
  fullHeight,
  previewAction,
  cardType,
  offerTimerProps,
  showBorder,
  showButton,
  buttonProps,
  hideOriginalPrice,
  isSellerPage,
  isSlider,
  hidePriceWhen,
  hideShippingTagWhen
}) {
  const handleCarouselChange = active => {
    const actives = Array(slidesPerView).fill().map((_, index) => products[index + active]);
    onChange(actives);
  };

  const showArrowControlsProp = showArrowControls && slidesPerView <= (products == null ? void 0 : products.length);
  const variations = {
    horizontal: ProductCardHorizontal/* default */.Z,
    vertical: ProductCard/* default */.Z
  };
  const Card = variations[cardType];
  return /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
    onChange: handleCarouselChange,
    slidesPerView: slidesPerView,
    gutter: gutter,
    auto: auto,
    interval: interval,
    showPartialNextSlide: showPartialNextSlide,
    transitionDuration: transitionDuration,
    isProductCarousel: true,
    showControls: showControls,
    showArrowControls: showArrowControlsProp,
    isSlider: isSlider,
    isSellerPage: isSellerPage
  }, products == null ? void 0 : products.map((product, index) => /*#__PURE__*/react.createElement(Card, (0,esm_extends/* default */.Z)({}, product, {
    displayMode: displayMode,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onView: onProductView,
    showInCashInfo: showInCashInfo,
    titleAs: productTitleAs,
    fullHeight: fullHeight,
    imageAltPrefix: imageAltPrefix,
    imgLazyLoading: imgLazyLoading,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    showRating: showRating,
    showOfferTimer: showOfferTimer,
    key: `product-carousel-${product.variationId || product.id}-${index}`,
    enableHover: enableHover,
    showPreview: showPreview,
    previewAction: previewAction,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    offerTimerProps: offerTimerProps,
    showBorder: showBorder,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: hideOriginalPrice,
    isSellerPage: isSellerPage,
    isSlider: isSlider,
    hidePriceWhen: hidePriceWhen,
    hideShippingTagWhen: hideShippingTagWhen
  }))));
}
 false ? 0 : void 0;
ProductCarousel.defaultProps = {
  displayMode: 'gallery',
  onClick: () => {},
  onMouseDown: () => {},
  onProductView: () => {},
  onChange: () => {},
  showInCashInfo: true,
  showPartialNextSlide: true,
  auto: true,
  slidesPerView: 2,
  interval: 5000,
  fullHeight: true,
  transitionDuration: 400,
  gutter: 2,
  productTitleAs: 'h2',
  imageAltPrefix: '',
  imgLazyLoading: true,
  showControls: true,
  showArrowControls: false,
  showRating: true,
  enableHover: true,
  showPreview: false,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  previewAction: () => {},
  cardType: 'vertical',
  showBorder: false,
  showOfferTimer: false,
  showButton: false,
  buttonProps: {},
  hideOriginalPrice: false,
  isSellerPage: false,
  isSlider: false,
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js


/***/ }),

/***/ 98284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var esm = __webpack_require__(87879);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 18 modules
var ProductCard = __webpack_require__(47719);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/InlineFilter/index.js + 2 modules
var InlineFilter = __webpack_require__(76228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list.styles.js








const variations = ({
  displayMode,
  isSlider,
  isSellerPage
}) => {
  if (isSlider) {
    return styled_components_browser_esm.css`
      display: flex;
      flex-direction: row;
      gap: 16px;
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    `;
  }

  if (isSellerPage && !isSlider) {
    return styled_components_browser_esm.css`
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      justify-content: flex-start;
    `;
  }

  const containerStyle = {
    gallery: styled_components_browser_esm.css`
      grid-template-columns: 1fr 1fr;
      ${(0,stereo_ui_styles_build_esm.getMediaQuery)('small')} {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      }
    `,
    list: styled_components_browser_esm.css`
      grid-template-columns: 1fr;
    `,
    miniature: styled_components_browser_esm.css`
      grid-template-columns: 1fr 1fr 1fr;
      ${(0,stereo_ui_styles_build_esm.getMediaQuery)('small')} {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      }
    `
  };
  return containerStyle[displayMode];
};

const NotFound = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(props => Object.assign({
  fontSize: [1, 2, 2, 2],
  py: 3,
  px: 2,
  color: 'text.scratched',
  borderRadius: 'medium',
  bg: 'transparent',
  textAlign: ['center', 'left', 'left', 'left'],
  boxShadow: [4, 'none', 'none', 'none']
}, props))`
  min-width: 280px;
  margin: 0 auto;
  border-radius: 4px;
  transition: width 0.2s ease;
  word-break: break-word;

  ${index_esm.shadow}
  ${stereo_ui_styles_build_esm.color}
  ${index_esm.space}
  ${index_esm.typography}
`;
const NotFoundTitle = styled_components_browser_esm["default"].h1.attrs(props => Object.assign({
  fontSize: [3, 5, 5, 5],
  fontWeight: 'regular'
}, props))`
  text-align: center;
  color: ${props => (0,stereo_ui_styles_build_esm.getTextColor)('base')(props)};
  line-height: normal;
  margin-bottom: 18px;
  span {
    color: ${props => (0,stereo_ui_styles_build_esm.getPaletteColor)('primary.base')(props)};
    display: inline-flex;
    word-wrap: break-word;
    overflow: hidden;
    max-height: 2.4em;
    line-height: 1.2em;
  }

  ${(0,stereo_ui_styles_build_esm.getMediaQuery)('small')} {
    text-align: left;
  }

  ${index_esm.typography}
`;
const SearchIconWrapper = styled_components_browser_esm["default"].span.attrs(() => ({
  mr: 3
}))`
  display: none;

  ${(0,stereo_ui_styles_build_esm.getMediaQuery)('small')} {
    display: block;
  }

  ${index_esm.space}
`;
const SearchIcon = (0,styled_components_browser_esm["default"])(build_esm/* Search */.olm).attrs(props => Object.assign({
  width: 60,
  height: 60,
  color: 'primary.base'
}, props))`
  ${stereo_ui_styles_build_esm.color}
`;
const Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(props => Object.assign({}, props))`
  margin: 0;
  overflow: ${props => props.isSlider ? 'visible' : 'hidden'};
  transition: width 0.2s ease;
`;
const product_list_styles_List = (0,styled_components_browser_esm["default"])(List/* default */.Z).attrs(props => Object.assign({
  gridGap: props.isSlider ? 0 : ['2px', '1px', '1px']
}, props))`
  ${({
  displayMode,
  isSlider,
  isSellerPage
}) => variations({
  displayMode,
  isSlider,
  isSellerPage
})}
  ${index_esm.grid}
`;
const ListAction = (0,styled_components_browser_esm["default"])(product_list_styles_List.Action).attrs(() => ({
  fontWeight: 'regular',
  color: 'background.primary',
  fill: 'background.primary'
}))`
  border-top: ${(0,stereo_ui_styles_build_esm.themeGet)('borders.0')};
`;
const ListItem = styled_components_browser_esm["default"].li`
  list-style: none;
  ${props => {
  if (props.isSlider) {
    const width = props.isSellerPage ? '218px' : '280px';
    return styled_components_browser_esm.css`
        flex: 0 0 auto;
        min-width: ${width};
        max-width: ${width};
        width: ${width};
      `;
  }

  if (props.isSellerPage && !props.isSlider) {
    return styled_components_browser_esm.css`
        flex: 0 0 auto;
        width: 263.59px;
        min-width: 263.59px;
        max-width: 263.59px;
      `;
  }

  return '';
}}
  > * {
    min-height: 100%;
  }
`;
const FilterListItem = styled_components_browser_esm["default"].li`
  list-style: none;
  grid-column: 1 / -1;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list-not-found.js




const ProductListNotFound = ({
  message,
  messageSecondary
}) => /*#__PURE__*/react.createElement(NotFound, {
  "data-testid": "product-list-empty"
}, /*#__PURE__*/react.createElement(SearchIconWrapper, null, /*#__PURE__*/react.createElement(SearchIcon, null)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(NotFoundTitle, null, message), messageSecondary || ''));

 false ? 0 : void 0;
ProductListNotFound.defaultProps = {
  messageSecondary: '',
  message: ''
};
/* harmony default export */ var product_list_not_found = (ProductListNotFound);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list.js










 // eslint-disable-next-line sonarjs/cognitive-complexity

const ProductList = /*#__PURE__*/(0,react.forwardRef)(function ProductList(_ref, ref) {
  var _ref2, _inlineFilters$attrib;

  let {
    isSlider,
    isSellerPage,
    hidePriceButtonAction,
    lazyLoadingOffset,
    onClickLoadMore,
    imgLazyLoading,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    imageAltPrefix,
    imageWidth,
    imageHeight,
    onClickWishBtn,
    previewAction,
    showFullListBtn,
    enableShadow,
    displayMode,
    enableHover,
    showPreview,
    showWishBtn,
    showMoreBtn,
    hidePrice,
    notFound,
    onClick,
    onMouseDown,
    onProductView,
    partial,
    titleAs,
    domain,
    jsonLD,
    allowEmptyRating,
    data,
    gridGap,
    onThumbnailClick,
    onVariationClick,
    colorMinLength,
    attributeStyle,
    offerTimerProps,
    addToCart,
    showAddToCartButton,
    hidePriceWhen,
    hideShippingTagWhen,
    inlineFilters,
    onFilterClick,
    onFilterView,
    filterSlidesPerView,
    filterItemHeight,
    desktopMode
  } = _ref,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["isSlider", "isSellerPage", "hidePriceButtonAction", "lazyLoadingOffset", "onClickLoadMore", "imgLazyLoading", "showInCashInfo", "showDiscount", "showDiscountOnlyCashInfo", "imageAltPrefix", "imageWidth", "imageHeight", "onClickWishBtn", "previewAction", "showFullListBtn", "enableShadow", "displayMode", "enableHover", "showPreview", "showWishBtn", "showMoreBtn", "hidePrice", "notFound", "onClick", "onMouseDown", "onProductView", "partial", "titleAs", "domain", "jsonLD", "allowEmptyRating", "data", "gridGap", "onThumbnailClick", "onVariationClick", "colorMinLength", "attributeStyle", "offerTimerProps", "addToCart", "showAddToCartButton", "hidePriceWhen", "hideShippingTagWhen", "inlineFilters", "onFilterClick", "onFilterView", "filterSlidesPerView", "filterItemHeight", "desktopMode"]);

  (_ref2 = ref) !== null && _ref2 !== void 0 ? _ref2 : ref = (0,react.useRef)(null);
  const [containerWidth, setContainerWidth] = (0,react.useState)(0);
  const [collapsed, setCollapsed] = (0,react.useState)(Boolean(partial));
  const props = partial && !showFullListBtn && {
    collapse: true,
    trigger: collapsed,
    collapsedIn: partial
  };
  react.useEffect(() => {
    var _ref3;

    if ((_ref3 = ref) != null && _ref3.current) {
      setContainerWidth(ref.current.clientWidth);
    }

    setCollapsed(Boolean(partial));
    return () => setCollapsed(false);
  }, [partial]);
  if (notFound) return /*#__PURE__*/react.createElement(product_list_not_found, notFound);
  const filterInterval = displayMode === constants/* LIST */.IY ? 3 : 4;
  const filtersToDistribute = (inlineFilters == null ? void 0 : (_inlineFilters$attrib = inlineFilters.attributeFilters) == null ? void 0 : _inlineFilters$attrib.slice(1)) || [];
  const distributedItems = filtersToDistribute.length > 0 ? (0,esm/* distributeFilters */.Sl)({
    products: data || [],
    filters: filtersToDistribute || [],
    startPosition: filterInterval,
    interval: filterInterval
  }) : (data || []).map(product => Object.assign({}, product, {
    itemType: 'product'
  }));

  const renderProductCard = (item, index) => {
    var _item$originalIndex;

    return /*#__PURE__*/react.createElement(ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({
      key: `product-${item.variationId || item.id}-${index}`,
      hidePriceButtonAction: hidePriceButtonAction,
      lazyLoadingOffset: lazyLoadingOffset,
      imgLazyLoading: imgLazyLoading,
      showInCashInfo: showInCashInfo,
      imageAltPrefix: imageAltPrefix,
      imageWidth: imageWidth,
      imageHeight: imageHeight,
      enableShadow: enableShadow,
      displayMode: displayMode,
      domain: domain,
      enableHover: enableHover,
      showPreview: showPreview,
      showWishBtn: showWishBtn,
      hidePrice: hidePrice,
      onClick: onClick,
      onMouseDown: onMouseDown,
      onView: onProductView,
      titleAs: titleAs,
      index: (_item$originalIndex = item.originalIndex) !== null && _item$originalIndex !== void 0 ? _item$originalIndex : index,
      showDiscount: showDiscount,
      showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
      onClickWishBtn: e => onClickWishBtn(e, item),
      previewAction: () => previewAction(item),
      allowEmptyRating: allowEmptyRating,
      containerWidth: containerWidth,
      onThumbnailClick: onThumbnailClick,
      onVariationClick: onVariationClick,
      colorMinLength: colorMinLength,
      attributeStyle: attributeStyle,
      offerTimerProps: offerTimerProps,
      isSellerPage: isSellerPage,
      isSlider: isSlider,
      addToCart: addToCart,
      showAddToCartButton: showAddToCartButton,
      hidePriceWhen: hidePriceWhen,
      hideShippingTagWhen: hideShippingTagWhen
    }, item));
  };

  const Products = distributedItems == null ? void 0 : distributedItems.map((item, index) => {
    var _item$originalIndex2;

    if (item.itemType === 'filter') {
      return /*#__PURE__*/react.createElement(FilterListItem, {
        key: `inline-filter-${item.filterIndex}`
      }, /*#__PURE__*/react.createElement(InlineFilter/* default */.Z, {
        filter: item,
        onItemClick: onFilterClick,
        onView: onFilterView,
        desktopMode: desktopMode,
        itemHeight: filterItemHeight,
        slidesPerView: filterSlidesPerView
      }));
    }

    return /*#__PURE__*/react.createElement(ListItem, {
      key: `product-item-${(_item$originalIndex2 = item.originalIndex) !== null && _item$originalIndex2 !== void 0 ? _item$originalIndex2 : index}`,
      isSlider: isSlider,
      isSellerPage: isSellerPage
    }, renderProductCard(item, index));
  });
  const action = showFullListBtn ? {
    label: constants/* LABEL_SHOW_FULL_LIST */.dz,
    props: constants/* ICON_SHOW_FULL_LIST */.Bl
  } : {
    label: constants/* LABEL_SHOW_MORE */.K9,
    props: constants/* ICON_SHOW_MORE */.Uh
  };
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref,
    "data-testid": "product-list"
  }, rest), /*#__PURE__*/react.createElement(product_list_styles_List, (0,esm_extends/* default */.Z)({}, props, {
    variant: "light",
    displayMode: displayMode,
    gridGap: gridGap,
    isSlider: isSlider,
    isSellerPage: isSellerPage,
    renderAction: !isSlider && (collapsed || showFullListBtn || showMoreBtn) && partial < data.length && /*#__PURE__*/react.createElement(ListAction, (0,esm_extends/* default */.Z)({
      onClick: () => {
        onClickLoadMore();
        setCollapsed(!collapsed);
      }
    }, action.props), action.label)
  }), Products), jsonLD && data && /*#__PURE__*/react.createElement(JsonLD/* default */.ZP, {
    schema: data.filter(item => {
      var _item$price;

      return (_item$price = item.price) == null ? void 0 : _item$price.price;
    }).map(item => (0,JsonLD/* productSchema */.Iy)({
      product: item,
      isList: true
    }, domain)),
    type: "ItemList"
  }));
});
 false ? 0 : void 0;
ProductList.defaultProps = {
  isSlider: false,
  isSellerPage: false,
  hidePriceButtonAction: null,
  showFullListBtn: false,
  displayMode: 'gallery',
  domain: constants/* MAGALU_DOMAIN */.RW,
  lazyLoadingOffset: 50,
  showInCashInfo: true,
  imgLazyLoading: true,
  showWishBtn: false,
  showPreview: false,
  showMoreBtn: false,
  imageAltPrefix: '',
  hidePrice: false,
  showDiscountOnlyCashInfo: false,
  showDiscount: false,
  titleAs: 'h2',
  jsonLD: true,
  partial: 0,
  allowEmptyRating: false,
  onThumbnailClick: null,
  onVariationClick: null,
  colorMinLength: 3,
  attributeStyle: {},
  onClickLoadMore: () => {},
  onClickWishBtn: () => {},
  previewAction: () => {},
  onClick: () => {},
  onMouseDown: () => {},
  onProductView: () => {},
  addToCart: () => {},
  showAddToCartButton: () => false,
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined,
  inlineFilters: null,
  onFilterClick: () => {},
  onFilterView: () => {},
  filterSlidesPerView: 5,
  filterItemHeight: 48,
  desktopMode: false
};
/* harmony default export */ var product_list = (ProductList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js


/***/ }),

/***/ 99970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_review_gallery; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/helpers.js
const EXHIBITION_CARDS_DESKTOP = 5;
const EXHIBITION_CARDS_MOBILE = 2;
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/product-review-gallery.styles.js


const GridContainer = (0,styled_components_browser_esm["default"])(atoms/* Grid */.rj)`
  overflow-x: auto;
  padding: 16px 0;
`;
const GridCard = (0,styled_components_browser_esm["default"])(atoms/* Grid */.rj)`
  gap: 12px;
  display: flex;
  flex-wrap: nowrap;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/product-review-gallery.js






const ProductReviewGallery = ({
  children,
  isMobile
}) => {
  const [itemsPerView, setItemsPerView] = (0,react.useState)(EXHIBITION_CARDS_MOBILE);
  (0,react.useEffect)(() => {
    if (!isMobile) {
      setItemsPerView(EXHIBITION_CARDS_DESKTOP);
    }
  }, []);

  const renderCarousel = slidesPerView => {
    return /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
      showArrowControls: true,
      showControls: false,
      auto: false,
      slidesPerView: slidesPerView
    }, children);
  };

  if (children.length > itemsPerView) {
    return renderCarousel(itemsPerView);
  }

  return /*#__PURE__*/react.createElement(GridContainer, {
    "data-testid": "gallery-without-carousel"
  }, /*#__PURE__*/react.createElement(GridCard, null, children));
};

 false ? 0 : void 0;
/* harmony default export */ var product_review_gallery = (ProductReviewGallery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js


/***/ }),

/***/ 77576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_review_popup; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/media-container.styles.js


const Video = (0,styled_components_browser_esm["default"])('video')`
  width: 100%;
  margin: auto;
  max-height: 55vh;
  border-radius: 15px;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
const ImageWrapper = styled_components_browser_esm["default"].div`
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 499px) {
    border-radius: 12px;
  }
`;
const PopupImage = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)`
  display: block;
  max-height: 55vh;
  width: auto;
  max-width: 100%;
  height: fit-content;
  border-radius: 15px;
  transform-origin: center center;
  object-fit: contain;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
const ImageContainer = styled_components_browser_esm["default"].div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/media-container.js




function getDimensions({
  renderedDimensions,
  containerSize,
  rotation,
  currentSlide,
  index
}) {
  if (!renderedDimensions || !containerSize || currentSlide !== index) {
    return {
      containerWidth: 'auto',
      dynamicHeight: 'auto',
      scale: 1
    };
  }

  if (rotation === 0 || rotation === 180) {
    return {
      containerWidth: 'auto',
      dynamicHeight: 'auto',
      scale: 1
    };
  }

  const imageOriginalWidth = renderedDimensions.width;
  const imageOriginalHeight = renderedDimensions.height;
  const isVerticalImage = imageOriginalHeight > imageOriginalWidth;

  if (!isVerticalImage) {
    return {
      containerWidth: 'auto',
      dynamicHeight: `${imageOriginalWidth}px`,
      scale: 1
    };
  }

  const rotatedWidth = imageOriginalHeight;
  const rotatedHeight = imageOriginalWidth;
  const availableWidth = containerSize.width;
  const availableHeight = containerSize.height;
  let scale = 1;

  if (rotatedWidth > availableWidth || rotatedHeight > availableHeight) {
    const scaleBasedOnWidth = availableWidth / rotatedWidth;
    const scaleBasedOnHeight = availableHeight / rotatedHeight;
    const safetyMargin = 0.95;
    scale = Math.min(scaleBasedOnWidth, scaleBasedOnHeight, 1) * safetyMargin;
  }

  return {
    containerWidth: '100%',
    dynamicHeight: 'auto',
    scale
  };
}

const MediaContainer = ({
  media,
  alt,
  currentSlide,
  index,
  rotation
}) => {
  const videoRef = (0,react.useRef)(null);
  const containerRef = (0,react.useRef)(null);
  const imageRef = (0,react.useRef)(null);
  const [wrapperStyle, setWrapperStyle] = (0,react.useState)({
    transform: `rotate(0deg) scale(1)`,
    overflow: 'hidden'
  });
  const [containerStyle, setContainerStyle] = (0,react.useState)({});
  const [renderedDimensions, setRenderedDimensions] = (0,react.useState)(null);
  const [containerSize, setContainerSize] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    if (videoRef.current && currentSlide !== index) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [currentSlide, index]);
  (0,react.useLayoutEffect)(() => {
    if (containerRef.current) {
      setContainerSize(containerRef.current.getBoundingClientRect());
    }
  }, [renderedDimensions, currentSlide, index]);

  const handleImageLoad = e => {
    setRenderedDimensions({
      width: e.target.offsetWidth,
      height: e.target.offsetHeight
    });
  };

  (0,react.useLayoutEffect)(() => {
    const {
      containerWidth,
      dynamicHeight,
      scale
    } = getDimensions({
      renderedDimensions,
      containerSize,
      rotation,
      currentSlide,
      index
    });
    setWrapperStyle({
      transform: `rotate(${rotation}deg) scale(${scale})`,
      height: dynamicHeight,
      overflow: 'visible',
      transformOrigin: 'center center'
    });
    setContainerStyle({
      width: containerWidth,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    });
  }, [rotation, renderedDimensions, containerSize, currentSlide, index]);
  return /*#__PURE__*/react.createElement(ImageContainer, {
    ref: containerRef,
    style: containerStyle
  }, media.mediaType === 'image' ? /*#__PURE__*/react.createElement(ImageWrapper, {
    style: wrapperStyle
  }, /*#__PURE__*/react.createElement(PopupImage, {
    ref: imageRef,
    alt: alt,
    src: media.mediaUrl,
    onLoad: handleImageLoad
  })) : /*#__PURE__*/react.createElement(Video, {
    ref: videoRef,
    muted: true,
    controls: true,
    type: "video/mp4",
    src: media.mediaUrl,
    "disablePictureIn-picture": "true",
    controlsList: "nodownload noplaybackrate"
  }));
};

 false ? 0 : void 0;
MediaContainer.defaultProps = {
  rotation: 0
};
/* harmony default export */ var media_container = (MediaContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/mobile-review-popup.styles.js





const ModalDetails = styled_components_browser_esm["default"].div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 20px 16px;
  z-index: ${(0,build_esm.themeGet)('zIndices.4')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: 500px) {
    display: none;
  }
`;
const DescriptionBlock = styled_components_browser_esm["default"].div`
  color: white;
  text-align: start;
  width: 100%;
`;
const ModalDetailsBody = styled_components_browser_esm["default"].div`
  margin: auto;
  ${(0,build_esm.getMediaQuery)('medium')} {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 720px;
    gap: 30px;
  }
`;
const ModalDetailsHeader = styled_components_browser_esm["default"].div`
  position: relative;
  display: flex;
  justify-content: end;
  width: 100%;
`;
const CloseButton = styled_components_browser_esm["default"].button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const SeeMore = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const CaroulselBlock = styled_components_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: calc(100% - 80px);
  margin: auto;
  ${(0,build_esm.getMediaQuery)('medium')} {
    max-width: 280px;
  }
`;
const ReviewContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)``;
const Header = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  padding: 0 0 ${props => (0,build_esm.themeGet)('space.2')(props)}px;
  ${(0,build_esm.getMediaQuery)('large')} {
    padding: 0 0 ${props => (0,build_esm.themeGet)('space.3')(props)}px;
  }
`;
const ReviewerName = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm.getTextColor)('white')(props)};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm.themeGet)('space.2')(props)}px;
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.plus')(props)}px;
`;
const ReviewWrapper = styled_components_browser_esm["default"].span`
  width: 80px;
`;
const RotateButtonBlock = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  width: 100%;
  height: 32px;
  margin: 18px 0 0;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js + 1 modules
var stereo_ui_utils_build_esm = __webpack_require__(87879);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/helpers.js

const validateShortDescription = (description, charLimit) => {
  return (description == null ? void 0 : description.length) <= charLimit;
};
const reduceDescription = (description, charLimit) => {
  return description == null ? void 0 : description.substring(0, charLimit).concat('...');
};
const verifyTimestamp = date => {
  return /^\d+$/.test(date);
};
const generateDateDistance = date => {
  return date && !verifyTimestamp(date) && (0,stereo_ui_utils_build_esm/* formatDateDistance */.jL)(new Date(date), new Date());
};
const formatSubtitle = productAttributes => {
  return (productAttributes == null ? void 0 : productAttributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/mobile-review-popup.js










const MobileReviewPopup = ({
  charLimit,
  children,
  closePopup,
  selectedMedia,
  review,
  changeCaroulsel,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const {
    rating,
    description,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  return /*#__PURE__*/react.createElement(ModalDetails, null, /*#__PURE__*/react.createElement(ModalDetailsHeader, null, /*#__PURE__*/react.createElement(CloseButton, {
    "data-testid": "close-popup",
    "aria-label": "fechar popup",
    onClick: closePopup
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "Close",
    color: "#FFF"
  }))), /*#__PURE__*/react.createElement(CaroulselBlock, null, /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
    auto: false,
    goTo: selectedMedia,
    verticalAlign: "center",
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/react.createElement(RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/react.createElement(Button/* default */.Z, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/react.createElement(esm/* ExchangeCircle */.tnm, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/react.createElement(ReviewContainer, {
    container: true
  }, /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(ReviewerName, null, userData.name), /*#__PURE__*/react.createElement(ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), /*#__PURE__*/react.createElement(DescriptionBlock, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos'))));
};

 false ? 0 : void 0;
MobileReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
/* harmony default export */ var mobile_review_popup = (MobileReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js + 3 modules
var ProductReviewGallery = __webpack_require__(99970);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/web-review-popup.styles.js







const web_review_popup_styles_Header = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  align-items: center;
  padding: 0 0 ${props => (0,build_esm.themeGet)('space.2')(props)}px;

  ${(0,build_esm.getMediaQuery)('large')} {
    padding: 0 0 ${props => (0,build_esm.themeGet)('space.3')(props)}px;
  }
`;
const web_review_popup_styles_ReviewerName = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm.themeGet)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm.themeGet)('space.2')(props)}px;
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.plus')(props)}px;
`;
const SubTitle = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${(0,build_esm.getTextColor)('davysGray')};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.plus')(props)}px;
`;
const DateWrapper = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${(0,build_esm.getTextColor)('davysGray')};
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm.themeGet)('lineHeights.tall')(props)}px;
`;
const Description = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(() => ({
  fontSize: 3
}))`
  color: ${(0,build_esm.themeGet)('colors.black')};
  font-weight: ${(0,build_esm.themeGet)('fontWeights.regular')};
  line-height: 24px;
  padding: ${(0,build_esm.themeGet)('space.3')}px 0 ${(0,build_esm.themeGet)('space.3')}px;
  word-break: break-word;
  width: 100%;
`;
const web_review_popup_styles_ModalDetailsBody = styled_components_browser_esm["default"].div`
  margin: 25px 0;
  display: flex;
  width: 100%;
  gap: 40px;
`;
const web_review_popup_styles_SeeMore = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const web_review_popup_styles_ReviewWrapper = styled_components_browser_esm["default"].span`
  width: 80px;
`;
const web_review_popup_styles_CaroulselBlock = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  gap: 18px;
  width: 50%;
`;
const web_review_popup_styles_ReviewContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  width: 50%;
`;
const DialogStyled = (0,styled_components_browser_esm["default"])(Dialog/* default */.Z)`
  width: 720px;
  background-color: ${(0,build_esm.getPaletteColor)('background.lighter')};
  padding: 20px;
  display: none;

  @media screen and (min-width: 500px) {
    display: block;
  }
`;
const DialogContent = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  min-height: 400px;
`;
const CondensedMediasBlock = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  width: 100%;
`;
const RotateButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)`
  width: 50%;
`;
const web_review_popup_styles_RotateButtonBlock = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  width: 100%;
  height: 32px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/web-review-popup.js










const modalTitleStyle = {
  color: '#51585C',
  fontWeight: 'bold'
};

const WebReviewPopup = ({
  changeCaroulsel,
  charLimit,
  children,
  closePopup,
  review,
  selectedMedia,
  thumbnails,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const [selectedCondensedMedia, setSelectedCondensedMedia] = (0,react.useState)(selectedMedia);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  const days = generateDateDistance(submissionDate);
  const subtitle = formatSubtitle(attributes);

  const renderGallery = () => {
    const renderedCards = thumbnails.map((media, index) => {
      return /*#__PURE__*/react.createElement(MediaReviewCard/* default */.Z, {
        key: `caroulsel-card-${media.mediaUrl}`,
        media: media,
        onClick: () => setSelectedCondensedMedia(index)
      });
    });
    return /*#__PURE__*/react.createElement(ProductReviewGallery/* default */.Z, null, renderedCards);
  };

  return /*#__PURE__*/react.createElement(DialogStyled, {
    position: "center",
    showClose: true,
    type: "responsive",
    onClickOutside: closePopup,
    title: "Avalia\xE7\xF5es com m\xEDdias",
    titleStyle: modalTitleStyle
  }, /*#__PURE__*/react.createElement(DialogContent, {
    flexDirection: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/react.createElement(web_review_popup_styles_ModalDetailsBody, null, /*#__PURE__*/react.createElement(web_review_popup_styles_CaroulselBlock, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
    showSlideCount: true,
    showArrowControls: true,
    showControls: false,
    auto: false,
    goTo: selectedCondensedMedia,
    verticalAlign: 'center',
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/react.createElement(web_review_popup_styles_RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/react.createElement(RotateButton, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/react.createElement(esm/* ExchangeCircle */.tnm, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewContainer, {
    container: true
  }, /*#__PURE__*/react.createElement(web_review_popup_styles_Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewerName, null, userData.name), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/react.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(web_review_popup_styles_SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/react.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`))), /*#__PURE__*/react.createElement(CondensedMediasBlock, null, renderGallery())));
};

 false ? 0 : void 0;
WebReviewPopup.defaultProps = {
  charLimit: 110,
  reviewDate: null,
  subtitle: ''
};
/* harmony default export */ var web_review_popup = (WebReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/product-review-popup.js





const rotationAngle = 90;

const ProductReviewPopup = ({
  review,
  charLimit,
  mediaProps,
  selectedMedia,
  closePopup,
  changeCaroulsel
}) => {
  const [currentSlide, setCurrentSlide] = (0,react.useState)(selectedMedia);
  const [showRotateButton, setShowRotateButton] = (0,react.useState)(false);
  const [mediaRotations, setMediaRotations] = (0,react.useState)({});
  const thumbnails = mediaProps.filter(item => item.thumbnails);
  const processedMedias = mediaProps.filter(item => item.processed);

  const verifyMediaType = index => {
    if (processedMedias[index]) {
      setShowRotateButton(processedMedias[index].mediaType !== 'video');
    }
  };

  (0,react.useEffect)(() => {
    verifyMediaType(currentSlide);
  }, [processedMedias, currentSlide]);

  const handleSlideChange = index => {
    setCurrentSlide(index);
    verifyMediaType(index);
    changeCaroulsel(index);
  };

  const handleRotateImage = () => {
    var _processedMedias$curr;

    const mediaId = (_processedMedias$curr = processedMedias[currentSlide]) == null ? void 0 : _processedMedias$curr.mediaUrl;
    if (!mediaId) return;
    setMediaRotations(prevRotations => {
      const currentRotation = prevRotations[mediaId] || 0;
      let newRotation = currentRotation + rotationAngle;

      if (newRotation >= 360) {
        newRotation = 0;
      }

      return Object.assign({}, prevRotations, {
        [mediaId]: newRotation
      });
    });
  };

  const renderMedia = (0,react.useCallback)(() => {
    return processedMedias.map((elem, index) => {
      const rotation = mediaRotations[elem.mediaUrl] || 0;
      return /*#__PURE__*/react.createElement(media_container, {
        key: `slide-item-${elem.mediaUrl}`,
        media: elem,
        alt: '',
        currentSlide: currentSlide,
        index: index,
        rotation: rotation
      });
    });
  }, [processedMedias, currentSlide, mediaRotations]);

  const closePopupAction = () => {
    closePopup();
  };

  const renderPopup = () => {
    if (window.innerWidth >= 500) {
      return /*#__PURE__*/react.createElement(web_review_popup, {
        charLimit: charLimit,
        closePopup: closePopup,
        review: review,
        selectedMedia: selectedMedia,
        changeCaroulsel: handleSlideChange,
        thumbnails: thumbnails,
        showRotateButton: showRotateButton,
        onRotateImage: handleRotateImage
      }, renderMedia());
    }

    return /*#__PURE__*/react.createElement(mobile_review_popup, {
      charLimit: charLimit,
      closePopup: closePopupAction,
      review: review,
      selectedMedia: selectedMedia,
      changeCaroulsel: handleSlideChange,
      showRotateButton: showRotateButton,
      onRotateImage: handleRotateImage
    }, renderMedia());
  };

  return renderPopup();
};

 false ? 0 : void 0;
ProductReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
/* harmony default export */ var product_review_popup = (ProductReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/index.js


/***/ })

}]);